const data = [
  {
    type: 'Feature',

    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-68.451, -70.956],
          [-68.334, -71.406],
          [-68.51, -71.798],
          [-68.784, -72.171],
          [-69.959, -72.308],
          [-71.076, -72.504],
          [-72.388, -72.484],
          [-71.898, -72.092],
          [-73.074, -72.229],
          [-74.19, -72.367],
          [-74.954, -72.073],
          [-75.013, -71.661],
          [-73.916, -71.269],
          [-73.916, -71.269],
          [-73.23, -71.152],
          [-72.075, -71.191],
          [-71.781, -70.681],
          [-71.722, -70.309],
          [-71.742, -69.506],
          [-71.174, -69.035],
          [-70.253, -68.879],
          [-69.724, -69.251],
          [-69.489, -69.623],
          [-69.059, -70.074],
          [-68.726, -70.505],
          [-68.451, -70.956],
        ],
      ],
    },
  },
  {
    type: 'Feature',

    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-58.614, -64.152],
          [-59.045, -64.368],
          [-59.789, -64.211],
          [-60.612, -64.309],
          [-61.297, -64.544],
          [-62.022, -64.799],
          [-62.512, -65.093],
          [-62.649, -65.485],
          [-62.59, -65.857],
          [-62.12, -66.19],
          [-62.806, -66.426],
          [-63.746, -66.504],
          [-64.294, -66.837],
          [-64.882, -67.15],
          [-65.508, -67.582],
          [-65.665, -67.954],
          [-65.313, -68.365],
          [-64.784, -68.679],
          [-63.961, -68.914],
          [-63.197, -69.228],
          [-62.786, -69.619],
          [-62.571, -69.992],
          [-62.277, -70.384],
          [-61.807, -70.717],
          [-61.513, -71.089],
          [-61.376, -72.01],
          [-61.082, -72.382],
          [-61.004, -72.774],
          [-60.69, -73.166],
          [-60.827, -73.695],
          [-61.376, -74.107],
          [-61.963, -74.44],
          [-63.295, -74.577],
          [-63.746, -74.93],
          [-64.353, -75.263],
          [-65.861, -75.635],
          [-67.193, -75.792],
          [-68.446, -76.007],
          [-69.798, -76.223],
          [-70.601, -76.634],
          [-72.207, -76.674],
          [-73.97, -76.634],
          [-75.556, -76.713],
          [-77.24, -76.713],
          [-76.927, -77.105],
          [-75.399, -77.281],
          [-74.283, -77.555],
          [-73.656, -77.908],
          [-74.773, -78.222],
          [-76.496, -78.124],
          [-77.926, -78.378],
          [-77.985, -78.79],
          [-78.024, -79.182],
          [-76.849, -79.515],
          [-76.633, -79.887],
          [-75.36, -80.26],
          [-73.245, -80.416],
          [-71.443, -80.691],
          [-70.013, -81.004],
          [-68.192, -81.318],
          [-65.704, -81.474],
          [-63.256, -81.749],
          [-61.552, -82.043],
          [-59.691, -82.376],
          [-58.712, -82.846],
          [-58.222, -83.218],
          [-57.008, -82.866],
          [-55.363, -82.572],
          [-53.62, -82.258],
          [-51.544, -82.004],
          [-49.761, -81.729],
          [-47.274, -81.71],
          [-44.826, -81.847],
          [-42.808, -82.082],
          [-42.162, -81.651],
          [-40.771, -81.357],
          [-38.245, -81.337],
          [-36.267, -81.122],
          [-34.386, -80.906],
          [-32.31, -80.769],
          [-30.097, -80.593],
          [-28.55, -80.338],
          [-29.255, -79.985],
          [-29.686, -79.633],
          [-29.686, -79.26],
          [-31.625, -79.299],
          [-33.681, -79.456],
          [-35.64, -79.456],
          [-35.914, -79.084],
          [-35.777, -78.339],
          [-35.327, -78.124],
          [-33.897, -77.889],
          [-32.212, -77.653],
          [-30.998, -77.36],
          [-29.784, -77.066],
          [-28.883, -76.674],
          [-27.512, -76.497],
          [-26.16, -76.36],
          [-25.475, -76.282],
          [-23.928, -76.243],
          [-22.459, -76.105],
          [-21.225, -75.909],
          [-20.01, -75.674],
          [-18.914, -75.439],
          [-17.523, -75.126],
          [-16.642, -74.793],
          [-15.701, -74.499],
          [-15.408, -74.107],
          [-16.465, -73.872],
          [-16.113, -73.46],
          [-15.447, -73.147],
          [-14.409, -72.951],
          [-13.312, -72.715],
          [-12.294, -72.402],
          [-11.51, -72.01],
          [-11.02, -71.54],
          [-10.296, -71.265],
          [-9.101, -71.324],
          [-8.611, -71.657],
          [-7.417, -71.697],
          [-7.377, -71.324],
          [-6.868, -70.932],
          [-5.791, -71.03],
          [-5.536, -71.403],
          [-4.342, -71.461],
          [-3.049, -71.285],
          [-1.795, -71.167],
          [-0.659, -71.226],
          [-0.229, -71.638],
          [0.868, -71.305],
          [1.887, -71.128],
          [3.023, -70.991],
          [4.139, -70.854],
          [5.158, -70.619],
          [6.274, -70.462],
          [7.136, -70.247],
          [7.743, -69.894],
          [8.487, -70.149],
          [9.525, -70.011],
          [10.25, -70.482],
          [10.818, -70.834],
          [11.954, -70.638],
          [12.404, -70.247],
          [13.423, -69.972],
          [14.735, -70.031],
          [15.127, -70.403],
          [15.949, -70.031],
          [17.027, -69.913],
          [18.202, -69.874],
          [19.259, -69.894],
          [20.376, -70.011],
          [21.453, -70.07],
          [21.923, -70.403],
          [22.569, -70.697],
          [23.666, -70.521],
          [24.841, -70.482],
          [25.977, -70.482],
          [27.094, -70.462],
          [28.093, -70.325],
          [29.15, -70.207],
          [30.032, -69.933],
          [30.972, -69.757],
          [31.99, -69.659],
          [32.754, -69.384],
          [33.302, -68.836],
          [33.87, -68.503],
          [34.908, -68.659],
          [35.3, -69.012],
          [36.162, -69.247],
          [37.2, -69.169],
          [37.905, -69.521],
          [38.649, -69.776],
          [39.668, -69.541],
          [40.02, -69.11],
          [40.921, -68.934],
          [41.959, -68.601],
          [42.939, -68.463],
          [44.114, -68.267],
          [44.897, -68.052],
          [45.72, -67.817],
          [46.503, -67.601],
          [47.443, -67.719],
          [48.344, -67.366],
          [48.991, -67.092],
          [49.931, -67.111],
          [50.753, -66.876],
          [50.949, -66.523],
          [51.792, -66.249],
          [52.614, -66.053],
          [53.613, -65.896],
          [54.534, -65.818],
          [55.415, -65.877],
          [56.355, -65.975],
          [57.158, -66.249],
          [57.256, -66.68],
          [58.137, -67.013],
          [58.745, -67.288],
          [59.939, -67.405],
          [60.605, -67.68],
          [61.428, -67.954],
          [62.387, -68.013],
          [63.19, -67.817],
          [64.052, -67.405],
          [64.992, -67.621],
          [65.972, -67.738],
          [66.912, -67.856],
          [67.891, -67.934],
          [68.89, -67.934],
          [69.713, -68.973],
          [69.673, -69.228],
          [69.556, -69.678],
          [68.596, -69.933],
          [67.813, -70.305],
          [67.95, -70.697],
          [69.066, -70.678],
          [68.929, -71.069],
          [68.42, -71.442],
          [67.95, -71.853],
          [68.714, -72.167],
          [69.869, -72.265],
          [71.025, -72.088],
          [71.573, -71.697],
          [71.906, -71.324],
          [72.455, -71.011],
          [73.081, -70.717],
          [73.336, -70.364],
          [73.865, -69.874],
          [74.492, -69.776],
          [75.628, -69.737],
          [76.626, -69.619],
          [77.645, -69.463],
          [78.135, -69.071],
          [78.428, -68.698],
          [79.114, -68.326],
          [80.093, -68.072],
          [80.935, -67.876],
          [81.484, -67.542],
          [82.052, -67.366],
          [82.776, -67.209],
          [83.775, -67.307],
          [84.676, -67.209],
          [85.656, -67.092],
          [86.752, -67.15],
          [87.477, -66.876],
          [87.986, -66.21],
          [88.358, -66.484],
          [88.828, -66.955],
          [89.671, -67.15],
          [90.63, -67.229],
          [91.59, -67.111],
          [92.609, -67.19],
          [93.549, -67.209],
          [94.175, -67.111],
          [95.018, -67.17],
          [95.781, -67.386],
          [96.682, -67.249],
          [97.76, -67.249],
          [98.68, -67.111],
          [99.718, -67.249],
          [100.384, -66.915],
          [100.893, -66.582],
          [101.579, -66.308],
          [102.832, -65.563],
          [103.479, -65.7],
          [104.243, -65.975],
          [104.908, -66.328],
          [106.182, -66.935],
          [107.161, -66.955],
          [108.081, -66.955],
          [109.159, -66.837],
          [110.236, -66.7],
          [111.058, -66.426],
          [111.744, -66.132],
          [112.86, -66.092],
          [113.605, -65.877],
          [114.388, -66.073],
          [114.897, -66.386],
          [115.602, -66.7],
          [116.699, -66.661],
          [117.385, -66.915],
          [118.579, -67.17],
          [119.833, -67.268],
          [120.871, -67.19],
          [121.654, -66.876],
          [122.32, -66.563],
          [123.221, -66.484],
          [124.122, -66.621],
          [125.16, -66.719],
          [126.1, -66.563],
          [127.001, -66.563],
          [127.883, -66.661],
          [128.803, -66.759],
          [129.704, -66.582],
          [130.781, -66.426],
          [131.8, -66.386],
          [132.936, -66.386],
          [133.856, -66.288],
          [134.757, -66.21],
          [135.032, -65.72],
          [135.071, -65.309],
          [135.697, -65.583],
          [135.874, -66.034],
          [136.207, -66.445],
          [136.618, -66.778],
          [137.46, -66.955],
          [138.596, -66.896],
          [139.908, -66.876],
          [140.809, -66.817],
          [142.122, -66.817],
          [143.062, -66.798],
          [144.374, -66.837],
          [145.49, -66.915],
          [146.196, -67.229],
          [146, -67.601],
          [146.646, -67.895],
          [147.723, -68.13],
          [148.84, -68.385],
          [150.132, -68.561],
          [151.484, -68.718],
          [152.502, -68.875],
          [153.638, -68.895],
          [154.285, -68.561],
          [155.166, -68.836],
          [155.93, -69.149],
          [156.811, -69.384],
          [158.026, -69.482],
          [159.181, -69.6],
          [159.671, -69.992],
          [160.807, -70.227],
          [161.57, -70.58],
          [162.687, -70.736],
          [163.842, -70.717],
          [164.92, -70.776],
          [166.114, -70.756],
          [167.309, -70.834],
          [168.426, -70.971],
          [169.464, -71.207],
          [170.502, -71.403],
          [171.207, -71.697],
          [171.089, -72.088],
          [170.56, -72.441],
          [170.11, -72.892],
          [169.757, -73.245],
          [169.287, -73.656],
          [167.975, -73.813],
          [167.387, -74.165],
          [166.095, -74.381],
          [165.644, -74.773],
          [164.959, -75.145],
          [164.234, -75.459],
          [163.823, -75.87],
          [163.568, -76.243],
          [163.47, -76.693],
          [163.49, -77.066],
          [164.058, -77.457],
          [164.273, -77.83],
          [164.743, -78.183],
          [166.604, -78.32],
          [166.996, -78.751],
          [165.194, -78.907],
          [163.666, -79.123],
          [161.766, -79.162],
          [160.924, -79.73],
          [160.748, -80.201],
          [160.317, -80.573],
          [159.788, -80.945],
          [161.12, -81.279],
          [161.629, -81.69],
          [162.491, -82.062],
          [163.705, -82.395],
          [165.096, -82.709],
          [166.604, -83.022],
          [168.896, -83.336],
          [169.405, -83.826],
          [172.284, -84.041],
          [172.477, -84.118],
          [173.224, -84.414],
          [175.986, -84.159],
          [178.277, -84.473],
          [180, -84.713],
          [180, -90],
          [-180, -90],
          [-180, -84.713],
          [-179.942, -84.721],
          [-179.059, -84.139],
          [-177.257, -84.453],
          [-177.141, -84.418],
          [-176.862, -84.334],
          [-176.524, -84.232],
          [-176.23, -84.143],
          [-176.085, -84.099],
          [-175.934, -84.102],
          [-175.83, -84.118],
          [-174.383, -84.534],
          [-173.117, -84.118],
          [-172.889, -84.061],
          [-169.951, -83.885],
          [-169, -84.118],
          [-168.53, -84.237],
          [-167.022, -84.57],
          [-164.182, -84.825],
          [-161.93, -85.139],
          [-158.071, -85.374],
          [-155.192, -85.1],
          [-150.942, -85.296],
          [-148.533, -85.609],
          [-145.889, -85.315],
          [-143.108, -85.041],
          [-142.892, -84.57],
          [-146.829, -84.531],
          [-150.061, -84.296],
          [-150.903, -83.904],
          [-153.586, -83.689],
          [-153.41, -83.238],
          [-153.038, -82.827],
          [-152.666, -82.454],
          [-152.862, -82.043],
          [-154.526, -81.768],
          [-155.29, -81.416],
          [-156.837, -81.102],
          [-154.409, -81.161],
          [-152.098, -81.004],
          [-150.648, -81.337],
          [-148.866, -81.043],
          [-147.221, -80.671],
          [-146.418, -80.338],
          [-146.77, -79.926],
          [-148.063, -79.652],
          [-149.532, -79.358],
          [-151.588, -79.299],
          [-153.39, -79.162],
          [-155.329, -79.064],
          [-155.976, -78.692],
          [-157.268, -78.378],
          [-158.052, -78.026],
          [-158.365, -76.889],
          [-157.875, -76.987],
          [-156.975, -77.301],
          [-155.329, -77.203],
          [-153.743, -77.066],
          [-152.92, -77.497],
          [-151.334, -77.399],
          [-150.002, -77.183],
          [-148.748, -76.909],
          [-147.612, -76.576],
          [-146.104, -76.478],
          [-146.144, -76.105],
          [-146.496, -75.733],
          [-146.202, -75.38],
          [-144.91, -75.204],
          [-144.322, -75.537],
          [-142.794, -75.341],
          [-141.639, -75.086],
          [-140.209, -75.067],
          [-138.858, -74.969],
          [-137.506, -74.734],
          [-136.429, -74.518],
          [-135.215, -74.303],
          [-134.431, -74.361],
          [-133.746, -74.44],
          [-132.257, -74.303],
          [-130.925, -74.479],
          [-129.554, -74.459],
          [-128.242, -74.322],
          [-126.891, -74.42],
          [-125.402, -74.518],
          [-124.011, -74.479],
          [-122.562, -74.499],
          [-121.074, -74.518],
          [-119.703, -74.479],
          [-118.684, -74.185],
          [-117.47, -74.028],
          [-116.216, -74.244],
          [-115.022, -74.068],
          [-113.944, -73.715],
          [-113.298, -74.028],
          [-112.945, -74.381],
          [-112.299, -74.714],
          [-111.261, -74.42],
          [-110.066, -74.793],
          [-108.715, -74.91],
          [-107.559, -75.184],
          [-106.149, -75.126],
          [-104.876, -74.949],
          [-103.368, -74.988],
          [-102.017, -75.126],
          [-100.646, -75.302],
          [-100.117, -74.871],
          [-100.763, -74.538],
          [-101.253, -74.185],
          [-102.545, -74.107],
          [-103.113, -73.734],
          [-103.329, -73.362],
          [-103.681, -72.618],
          [-102.917, -72.755],
          [-101.605, -72.813],
          [-100.313, -72.755],
          [-99.137, -72.911],
          [-98.119, -73.205],
          [-97.688, -73.558],
          [-96.337, -73.617],
          [-95.044, -73.48],
          [-93.673, -73.284],
          [-92.439, -73.166],
          [-91.421, -73.401],
          [-90.089, -73.323],
          [-89.227, -72.559],
          [-88.424, -73.009],
          [-87.268, -73.186],
          [-86.015, -73.088],
          [-85.192, -73.48],
          [-83.88, -73.519],
          [-82.666, -73.636],
          [-81.471, -73.852],
          [-80.687, -73.48],
          [-80.296, -73.127],
          [-79.297, -73.519],
          [-77.926, -73.421],
          [-76.907, -73.636],
          [-76.222, -73.97],
          [-74.89, -73.872],
          [-73.852, -73.656],
          [-72.834, -73.401],
          [-71.619, -73.264],
          [-70.209, -73.147],
          [-68.936, -73.009],
          [-67.957, -72.794],
          [-67.369, -72.48],
          [-67.134, -72.049],
          [-67.252, -71.638],
          [-67.565, -71.246],
          [-67.917, -70.854],
          [-68.231, -70.462],
          [-68.485, -70.109],
          [-68.544, -69.717],
          [-68.446, -69.326],
          [-67.976, -68.953],
          [-67.584, -68.542],
          [-67.428, -68.15],
          [-67.624, -67.719],
          [-67.741, -67.327],
          [-67.252, -66.876],
          [-66.703, -66.582],
          [-66.057, -66.21],
          [-65.371, -65.896],
          [-64.568, -65.603],
          [-64.177, -65.171],
          [-63.628, -64.897],
          [-63.001, -64.642],
          [-62.042, -64.584],
          [-61.415, -64.27],
          [-60.71, -64.074],
          [-59.887, -63.957],
          [-59.163, -63.702],
          [-58.595, -63.388],
          [-57.811, -63.271],
          [-57.224, -63.525],
          [-57.596, -63.859],
          [-58.614, -64.152],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [150.732, 75.084],
          [149.576, 74.689],
          [147.977, 74.778],
          [146.119, 75.173],
          [146.358, 75.497],
          [148.222, 75.346],
          [150.732, 75.084],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [105.075, 78.307],
          [99.438, 77.921],
          [101.265, 79.234],
          [102.086, 79.346],
          [102.838, 79.281],
          [105.372, 78.713],
          [105.075, 78.307],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [18.252, 79.702],
          [21.544, 78.956],
          [19.027, 78.563],
          [18.472, 77.827],
          [17.594, 77.638],
          [17.118, 76.809],
          [15.913, 76.77],
          [13.763, 77.38],
          [14.67, 77.736],
          [13.171, 78.025],
          [11.222, 78.869],
          [10.445, 79.652],
          [13.171, 80.01],
          [13.719, 79.66],
          [15.143, 79.674],
          [15.523, 80.016],
          [16.991, 80.051],
          [18.252, 79.702],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [99.94, 78.881],
          [97.758, 78.756],
          [94.973, 79.045],
          [93.313, 79.427],
          [92.545, 80.144],
          [91.181, 80.341],
          [93.778, 81.025],
          [95.941, 81.25],
          [97.884, 80.747],
          [100.187, 79.78],
          [99.94, 78.881],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [24.724, 77.854],
          [22.49, 77.445],
          [20.726, 77.677],
          [21.416, 77.935],
          [20.812, 78.255],
          [22.884, 78.455],
          [23.281, 78.08],
          [24.724, 77.854],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [25.448, 80.407],
          [27.408, 80.056],
          [25.925, 79.518],
          [23.024, 79.4],
          [20.075, 79.567],
          [19.897, 79.842],
          [18.462, 79.86],
          [17.368, 80.319],
          [20.456, 80.598],
          [21.908, 80.358],
          [22.919, 80.657],
          [25.448, 80.407],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [51.136, 80.547],
          [49.794, 80.415],
          [48.894, 80.34],
          [48.755, 80.175],
          [47.586, 80.01],
          [46.503, 80.247],
          [47.072, 80.559],
          [44.847, 80.59],
          [46.799, 80.772],
          [48.318, 80.784],
          [48.523, 80.515],
          [49.097, 80.754],
          [50.04, 80.919],
          [51.523, 80.7],
          [51.136, 80.547],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [143.91, 44.174],
          [144.613, 43.961],
          [145.321, 44.385],
          [145.543, 43.262],
          [144.06, 42.988],
          [143.184, 41.995],
          [141.611, 42.679],
          [141.067, 41.585],
          [139.955, 41.57],
          [139.818, 42.564],
          [140.312, 43.333],
          [141.381, 43.389],
          [141.672, 44.772],
          [141.968, 45.551],
          [143.143, 44.51],
          [143.91, 44.174],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [143.648, 50.748],
          [144.654, 48.976],
          [143.174, 49.307],
          [142.559, 47.862],
          [143.533, 46.837],
          [143.505, 46.138],
          [142.748, 46.741],
          [142.092, 45.967],
          [141.907, 46.806],
          [142.018, 47.78],
          [141.904, 48.859],
          [142.136, 49.615],
          [142.18, 50.952],
          [141.594, 51.935],
          [141.683, 53.302],
          [142.607, 53.762],
          [142.21, 54.225],
          [142.655, 54.366],
          [142.915, 53.705],
          [143.261, 52.741],
          [143.235, 51.757],
          [143.648, 50.748],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [[[12.69, 55.61], [12.09, 54.8], [11.044, 55.365], [10.904, 55.78], [12.371, 56.111], [12.69, 55.61]]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [57.536, 70.72],
          [56.945, 70.633],
          [53.677, 70.763],
          [53.412, 71.207],
          [51.602, 71.475],
          [51.456, 72.015],
          [52.478, 72.229],
          [52.444, 72.775],
          [54.428, 73.628],
          [53.508, 73.75],
          [55.902, 74.627],
          [55.632, 75.081],
          [57.869, 75.609],
          [61.17, 76.252],
          [64.498, 76.439],
          [66.211, 76.81],
          [68.157, 76.94],
          [68.852, 76.545],
          [68.181, 76.234],
          [64.637, 75.738],
          [61.584, 75.261],
          [58.477, 74.309],
          [56.987, 73.333],
          [55.419, 72.371],
          [55.623, 71.541],
          [57.536, 70.72],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [145.086, 75.563],
          [144.3, 74.82],
          [140.614, 74.848],
          [138.955, 74.611],
          [136.974, 75.262],
          [137.512, 75.949],
          [138.831, 76.137],
          [141.472, 76.093],
          [145.086, 75.563],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [[[180, 70.832], [178.903, 70.781], [178.725, 71.099], [180, 71.516], [180, 70.832]]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [143.604, 73.212],
          [142.088, 73.205],
          [140.038, 73.317],
          [139.863, 73.37],
          [140.812, 73.765],
          [142.062, 73.858],
          [143.483, 73.475],
          [143.604, 73.212],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [121.176, 22.791],
          [120.747, 21.971],
          [120.22, 22.815],
          [120.106, 23.556],
          [120.695, 24.538],
          [121.495, 25.295],
          [121.951, 24.998],
          [121.778, 24.394],
          [121.176, 22.791],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [140.976, 37.142],
          [140.6, 36.344],
          [140.774, 35.843],
          [140.253, 35.138],
          [138.976, 34.668],
          [137.218, 34.606],
          [135.793, 33.465],
          [135.121, 33.849],
          [135.079, 34.597],
          [133.34, 34.376],
          [132.157, 33.905],
          [130.986, 33.886],
          [132, 33.15],
          [131.333, 31.45],
          [130.686, 31.03],
          [130.202, 31.418],
          [130.448, 32.319],
          [129.815, 32.61],
          [129.408, 33.296],
          [130.354, 33.604],
          [130.878, 34.233],
          [131.884, 34.75],
          [132.618, 35.433],
          [134.608, 35.732],
          [135.678, 35.527],
          [136.724, 37.305],
          [137.391, 36.827],
          [138.858, 37.827],
          [139.426, 38.216],
          [140.055, 39.439],
          [139.883, 40.563],
          [140.306, 41.195],
          [141.369, 41.379],
          [141.914, 39.992],
          [141.885, 39.181],
          [140.959, 38.174],
          [140.976, 37.142],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [134.638, 34.149],
          [134.766, 33.806],
          [134.203, 33.201],
          [133.793, 33.522],
          [133.28, 33.29],
          [133.015, 32.705],
          [132.363, 32.989],
          [132.371, 33.464],
          [132.924, 34.06],
          [133.493, 33.945],
          [133.904, 34.365],
          [134.638, 34.149],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [15.52, 38.231],
          [15.16, 37.444],
          [15.31, 37.134],
          [15.1, 36.62],
          [14.335, 36.997],
          [13.827, 37.105],
          [12.431, 37.613],
          [12.571, 38.126],
          [13.741, 38.035],
          [14.761, 38.144],
          [15.52, 38.231],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [34.576, 35.672],
          [33.901, 35.246],
          [33.974, 35.059],
          [34.005, 34.978],
          [32.98, 34.572],
          [32.49, 34.702],
          [32.257, 35.103],
          [32.732, 35.14],
          [32.802, 35.146],
          [32.947, 35.387],
          [33.667, 35.373],
          [34.576, 35.672],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [23.7, 35.705],
          [24.247, 35.368],
          [25.025, 35.425],
          [25.769, 35.354],
          [25.745, 35.18],
          [26.29, 35.3],
          [26.165, 35.005],
          [24.725, 34.92],
          [24.735, 35.085],
          [23.515, 35.28],
          [23.7, 35.705],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [[[9.56, 42.152], [9.23, 41.38], [8.776, 41.584], [8.544, 42.257], [8.746, 42.628], [9.39, 43.01], [9.56, 42.152]]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-14.509, 66.456],
          [-14.74, 65.809],
          [-13.61, 65.127],
          [-14.91, 64.364],
          [-17.794, 63.679],
          [-18.656, 63.496],
          [-19.973, 63.644],
          [-22.763, 63.96],
          [-21.778, 64.402],
          [-23.955, 64.891],
          [-22.184, 65.085],
          [-22.227, 65.379],
          [-24.326, 65.611],
          [-23.651, 66.263],
          [-22.135, 66.41],
          [-20.576, 65.732],
          [-19.057, 66.277],
          [-17.799, 65.994],
          [-16.168, 66.527],
          [-14.509, 66.456],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-93.196, 72.772],
          [-94.269, 72.025],
          [-95.41, 72.062],
          [-96.034, 72.94],
          [-96.018, 73.437],
          [-95.496, 73.862],
          [-94.504, 74.135],
          [-92.42, 74.1],
          [-90.51, 73.857],
          [-92.004, 72.966],
          [-93.196, 72.772],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-75.866, 67.149],
          [-76.987, 67.099],
          [-77.236, 67.588],
          [-76.812, 68.149],
          [-75.895, 68.287],
          [-75.114, 68.01],
          [-75.103, 67.582],
          [-75.216, 67.444],
          [-75.866, 67.149],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-76.34, 73.103],
          [-76.251, 72.826],
          [-77.314, 72.856],
          [-78.392, 72.877],
          [-79.486, 72.742],
          [-79.776, 72.803],
          [-80.876, 73.333],
          [-80.834, 73.693],
          [-80.353, 73.76],
          [-78.064, 73.652],
          [-76.34, 73.103],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [[-93.84, 77.52], [-94.296, 77.491], [-96.17, 77.555], [-96.436, 77.835], [-94.423, 77.82], [-93.721, 77.634], [-93.84, 77.52]],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-68.5, 83.106],
          [-65.827, 83.028],
          [-63.68, 82.9],
          [-61.85, 82.629],
          [-61.894, 82.362],
          [-64.334, 81.928],
          [-66.753, 81.725],
          [-67.658, 81.501],
          [-65.48, 81.507],
          [-67.84, 80.9],
          [-69.47, 80.617],
          [-71.18, 79.8],
          [-73.243, 79.634],
          [-73.88, 79.43],
          [-76.908, 79.323],
          [-75.529, 79.198],
          [-76.22, 79.019],
          [-75.393, 78.526],
          [-76.344, 78.183],
          [-77.889, 77.9],
          [-78.363, 77.509],
          [-79.76, 77.21],
          [-79.62, 76.983],
          [-77.911, 77.022],
          [-77.889, 76.778],
          [-80.561, 76.178],
          [-83.174, 76.454],
          [-86.112, 76.299],
          [-87.6, 76.42],
          [-89.491, 76.472],
          [-89.616, 76.952],
          [-87.767, 77.178],
          [-88.26, 77.9],
          [-87.65, 77.97],
          [-84.976, 77.539],
          [-86.34, 78.18],
          [-87.962, 78.372],
          [-87.152, 78.759],
          [-85.379, 78.997],
          [-85.095, 79.345],
          [-86.507, 79.736],
          [-86.932, 80.251],
          [-84.198, 80.208],
          [-83.409, 80.1],
          [-81.848, 80.464],
          [-84.1, 80.58],
          [-87.599, 80.516],
          [-89.367, 80.856],
          [-90.2, 81.26],
          [-91.368, 81.553],
          [-91.587, 81.894],
          [-90.1, 82.085],
          [-88.932, 82.118],
          [-86.97, 82.28],
          [-85.5, 82.652],
          [-84.26, 82.6],
          [-83.18, 82.32],
          [-82.42, 82.86],
          [-81.1, 83.02],
          [-79.307, 83.131],
          [-76.25, 83.172],
          [-75.719, 83.064],
          [-72.832, 83.233],
          [-70.666, 83.17],
          [-68.5, 83.106],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-87.02, 79.66],
          [-85.814, 79.337],
          [-87.188, 79.039],
          [-89.035, 78.287],
          [-90.804, 78.215],
          [-92.877, 78.343],
          [-93.951, 78.751],
          [-93.936, 79.114],
          [-93.145, 79.38],
          [-94.974, 79.372],
          [-96.076, 79.705],
          [-96.71, 80.158],
          [-96.016, 80.602],
          [-95.323, 80.907],
          [-94.298, 80.977],
          [-94.735, 81.206],
          [-92.41, 81.257],
          [-91.133, 80.723],
          [-89.45, 80.509],
          [-87.81, 80.32],
          [-87.02, 79.66],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-3.005, 58.635],
          [-4.074, 57.553],
          [-3.055, 57.69],
          [-1.959, 57.685],
          [-2.22, 56.87],
          [-3.119, 55.974],
          [-2.085, 55.91],
          [-1.115, 54.625],
          [-0.43, 54.464],
          [0.185, 53.325],
          [0.47, 52.93],
          [1.682, 52.74],
          [1.56, 52.1],
          [1.051, 51.807],
          [1.45, 51.289],
          [0.55, 50.766],
          [-0.788, 50.775],
          [-2.49, 50.5],
          [-2.956, 50.697],
          [-3.617, 50.228],
          [-4.543, 50.342],
          [-5.245, 49.96],
          [-5.777, 50.16],
          [-4.31, 51.21],
          [-3.415, 51.426],
          [-4.984, 51.593],
          [-5.267, 51.991],
          [-4.222, 52.301],
          [-4.77, 52.84],
          [-4.58, 53.495],
          [-3.092, 53.404],
          [-2.945, 53.985],
          [-3.63, 54.615],
          [-4.844, 54.791],
          [-5.083, 55.062],
          [-4.719, 55.508],
          [-5.048, 55.784],
          [-5.586, 55.311],
          [-5.645, 56.275],
          [-6.15, 56.785],
          [-5.787, 57.819],
          [-5.01, 58.63],
          [-4.211, 58.551],
          [-3.005, 58.635],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-79.266, 62.159],
          [-79.658, 61.633],
          [-80.1, 61.718],
          [-80.362, 62.016],
          [-80.315, 62.086],
          [-79.929, 62.386],
          [-79.52, 62.364],
          [-79.266, 62.159],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-6.789, 52.26],
          [-8.562, 51.669],
          [-9.977, 51.82],
          [-9.166, 52.865],
          [-9.689, 53.881],
          [-8.328, 54.665],
          [-7.572, 55.132],
          [-6.734, 55.173],
          [-5.662, 54.555],
          [-6.198, 53.868],
          [-6.033, 53.153],
          [-6.789, 52.26],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-81.898, 62.711],
          [-83.069, 62.159],
          [-83.775, 62.182],
          [-83.994, 62.453],
          [-83.25, 62.914],
          [-81.877, 62.905],
          [-81.898, 62.711],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-86.562, 73.157],
          [-85.774, 72.534],
          [-84.85, 73.34],
          [-82.316, 73.751],
          [-80.6, 72.717],
          [-80.749, 72.062],
          [-78.771, 72.352],
          [-77.825, 72.75],
          [-75.606, 72.244],
          [-74.229, 71.767],
          [-74.099, 71.331],
          [-72.242, 71.557],
          [-71.2, 70.92],
          [-68.786, 70.525],
          [-67.915, 70.122],
          [-66.969, 69.186],
          [-68.805, 68.72],
          [-66.45, 68.067],
          [-64.862, 67.848],
          [-63.425, 66.928],
          [-61.852, 66.862],
          [-62.163, 66.16],
          [-63.918, 64.999],
          [-65.149, 65.426],
          [-66.721, 66.388],
          [-68.015, 66.263],
          [-68.141, 65.69],
          [-67.09, 65.108],
          [-65.732, 64.648],
          [-65.32, 64.383],
          [-64.669, 63.393],
          [-65.014, 62.674],
          [-66.275, 62.945],
          [-68.783, 63.746],
          [-67.37, 62.884],
          [-66.328, 62.28],
          [-66.166, 61.931],
          [-68.877, 62.33],
          [-71.023, 62.911],
          [-72.235, 63.398],
          [-71.886, 63.68],
          [-73.378, 64.194],
          [-74.834, 64.679],
          [-74.819, 64.389],
          [-77.71, 64.23],
          [-78.556, 64.573],
          [-77.897, 65.309],
          [-76.018, 65.327],
          [-73.96, 65.455],
          [-74.294, 65.812],
          [-73.945, 66.311],
          [-72.651, 67.285],
          [-72.926, 67.727],
          [-73.312, 68.069],
          [-74.843, 68.555],
          [-76.869, 68.895],
          [-76.229, 69.148],
          [-77.287, 69.77],
          [-78.169, 69.826],
          [-78.957, 70.167],
          [-79.492, 69.872],
          [-81.305, 69.743],
          [-84.945, 69.967],
          [-87.06, 70.26],
          [-88.682, 70.411],
          [-89.513, 70.762],
          [-88.468, 71.218],
          [-89.888, 71.223],
          [-90.205, 72.235],
          [-89.437, 73.129],
          [-88.408, 73.538],
          [-85.826, 73.804],
          [-86.562, 73.157],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-27.1, 83.52],
          [-20.845, 82.727],
          [-22.692, 82.342],
          [-26.518, 82.298],
          [-31.9, 82.2],
          [-31.396, 82.022],
          [-27.857, 82.132],
          [-24.844, 81.787],
          [-22.903, 82.093],
          [-22.072, 81.734],
          [-23.17, 81.153],
          [-20.624, 81.525],
          [-15.768, 81.912],
          [-12.77, 81.719],
          [-12.209, 81.292],
          [-16.285, 80.58],
          [-16.85, 80.35],
          [-20.046, 80.177],
          [-17.73, 80.129],
          [-18.9, 79.4],
          [-19.705, 78.751],
          [-19.674, 77.639],
          [-18.473, 76.986],
          [-20.035, 76.944],
          [-21.679, 76.628],
          [-19.834, 76.098],
          [-19.599, 75.248],
          [-20.668, 75.156],
          [-19.373, 74.296],
          [-21.594, 74.224],
          [-20.435, 73.817],
          [-20.762, 73.464],
          [-22.172, 73.31],
          [-23.566, 73.307],
          [-22.313, 72.629],
          [-22.3, 72.184],
          [-24.278, 72.598],
          [-24.793, 72.33],
          [-23.443, 72.08],
          [-22.133, 71.469],
          [-21.754, 70.664],
          [-23.536, 70.471],
          [-24.307, 70.856],
          [-25.543, 71.431],
          [-25.201, 70.752],
          [-26.363, 70.226],
          [-23.727, 70.184],
          [-22.349, 70.129],
          [-25.029, 69.259],
          [-27.747, 68.47],
          [-30.674, 68.125],
          [-31.777, 68.121],
          [-32.811, 67.735],
          [-34.202, 66.68],
          [-36.353, 65.979],
          [-37.044, 65.938],
          [-38.375, 65.692],
          [-39.812, 65.458],
          [-40.669, 64.84],
          [-40.683, 64.139],
          [-41.189, 63.482],
          [-42.819, 62.682],
          [-42.417, 61.901],
          [-42.866, 61.074],
          [-43.378, 60.098],
          [-44.787, 60.037],
          [-46.264, 60.853],
          [-48.263, 60.858],
          [-49.233, 61.407],
          [-49.9, 62.383],
          [-51.633, 63.627],
          [-52.14, 64.278],
          [-52.277, 65.177],
          [-53.662, 66.1],
          [-53.302, 66.837],
          [-53.969, 67.189],
          [-52.98, 68.358],
          [-51.475, 68.73],
          [-51.08, 69.148],
          [-50.871, 69.929],
          [-52.014, 69.575],
          [-52.558, 69.426],
          [-53.456, 69.284],
          [-54.683, 69.61],
          [-54.75, 70.289],
          [-54.359, 70.821],
          [-53.431, 70.836],
          [-51.39, 70.57],
          [-53.109, 71.205],
          [-54.004, 71.547],
          [-55, 71.407],
          [-55.835, 71.654],
          [-54.718, 72.586],
          [-55.326, 72.959],
          [-56.12, 73.65],
          [-57.324, 74.71],
          [-58.597, 75.099],
          [-58.585, 75.517],
          [-61.269, 76.102],
          [-63.392, 76.175],
          [-66.064, 76.135],
          [-68.504, 76.061],
          [-69.665, 76.38],
          [-71.403, 77.009],
          [-68.777, 77.323],
          [-66.764, 77.376],
          [-71.043, 77.636],
          [-73.297, 78.044],
          [-73.159, 78.433],
          [-69.373, 78.914],
          [-65.711, 79.394],
          [-65.324, 79.758],
          [-68.023, 80.117],
          [-67.151, 80.516],
          [-63.689, 81.214],
          [-62.234, 81.321],
          [-62.651, 81.77],
          [-60.282, 82.034],
          [-57.207, 82.191],
          [-54.134, 82.2],
          [-53.043, 81.888],
          [-50.391, 82.439],
          [-48.004, 82.065],
          [-46.6, 81.986],
          [-44.523, 81.661],
          [-46.901, 82.2],
          [-46.764, 82.628],
          [-43.406, 83.225],
          [-39.898, 83.18],
          [-38.622, 83.549],
          [-35.088, 83.645],
          [-27.1, 83.52],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-85.161, 65.657],
          [-84.976, 65.218],
          [-84.464, 65.372],
          [-83.883, 65.11],
          [-82.788, 64.767],
          [-81.642, 64.455],
          [-81.553, 63.98],
          [-80.817, 64.057],
          [-80.103, 63.726],
          [-80.991, 63.411],
          [-82.547, 63.652],
          [-83.109, 64.102],
          [-84.1, 63.57],
          [-85.523, 63.052],
          [-85.867, 63.637],
          [-87.222, 63.541],
          [-86.353, 64.036],
          [-86.225, 64.823],
          [-85.884, 65.739],
          [-85.161, 65.657],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [9.21, 41.21],
          [9.81, 40.5],
          [9.67, 39.177],
          [9.215, 39.24],
          [8.807, 38.907],
          [8.428, 39.172],
          [8.388, 40.378],
          [8.16, 40.95],
          [8.71, 40.9],
          [9.21, 41.21],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-56.134, 50.687],
          [-56.796, 49.812],
          [-56.143, 50.15],
          [-55.471, 49.936],
          [-55.822, 49.587],
          [-54.935, 49.313],
          [-54.474, 49.557],
          [-53.477, 49.249],
          [-53.786, 48.517],
          [-53.086, 48.688],
          [-52.959, 48.157],
          [-52.648, 47.536],
          [-53.069, 46.655],
          [-53.521, 46.618],
          [-54.179, 46.807],
          [-53.962, 47.625],
          [-54.24, 47.752],
          [-55.401, 46.885],
          [-55.997, 46.92],
          [-55.291, 47.39],
          [-56.251, 47.633],
          [-57.325, 47.573],
          [-59.266, 47.603],
          [-59.419, 47.899],
          [-58.797, 48.252],
          [-59.232, 48.523],
          [-58.392, 49.126],
          [-57.359, 50.718],
          [-56.739, 51.287],
          [-55.871, 51.632],
          [-55.407, 51.588],
          [-55.6, 51.317],
          [-56.134, 50.687],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-63.664, 46.55],
          [-62.939, 46.416],
          [-62.012, 46.443],
          [-62.504, 46.033],
          [-62.874, 45.968],
          [-64.143, 46.393],
          [-64.393, 46.727],
          [-64.015, 47.036],
          [-63.664, 46.55],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-77.535, 23.76],
          [-77.78, 23.71],
          [-78.034, 24.286],
          [-78.408, 24.576],
          [-78.191, 25.21],
          [-77.89, 25.17],
          [-77.54, 24.34],
          [-77.535, 23.76],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [[-77, 26.59], [-77.173, 25.879], [-77.356, 26.007], [-77.34, 26.53], [-77.788, 26.925], [-77.79, 27.04], [-77, 26.59]],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [[[-77.82, 26.58], [-78.91, 26.42], [-78.98, 26.79], [-78.51, 26.87], [-77.85, 26.84], [-77.82, 26.58]]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-61.806, 49.105],
          [-62.293, 49.087],
          [-63.589, 49.401],
          [-64.519, 49.873],
          [-64.173, 49.957],
          [-62.858, 49.706],
          [-61.836, 49.289],
          [-61.806, 49.105],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-93.613, 74.98],
          [-94.157, 74.592],
          [-95.609, 74.667],
          [-96.821, 74.928],
          [-96.289, 75.378],
          [-94.851, 75.647],
          [-93.978, 75.296],
          [-93.613, 74.98],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-98.5, 76.72],
          [-97.736, 76.257],
          [-97.704, 75.743],
          [-98.16, 75],
          [-99.809, 74.897],
          [-100.884, 75.057],
          [-100.863, 75.641],
          [-102.502, 75.564],
          [-102.566, 76.337],
          [-101.49, 76.305],
          [-99.983, 76.646],
          [-98.577, 76.589],
          [-98.5, 76.72],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-116.199, 77.645],
          [-116.336, 76.877],
          [-117.106, 76.53],
          [-118.04, 76.481],
          [-119.899, 76.053],
          [-121.5, 75.9],
          [-122.855, 76.117],
          [-122.855, 76.117],
          [-121.158, 76.865],
          [-119.104, 77.512],
          [-117.57, 77.498],
          [-116.199, 77.645],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-110.187, 77.697],
          [-112.051, 77.409],
          [-113.534, 77.732],
          [-112.725, 78.051],
          [-111.264, 78.153],
          [-109.854, 77.996],
          [-110.187, 77.697],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-95.83, 78.057],
          [-97.31, 77.851],
          [-98.124, 78.083],
          [-98.553, 78.458],
          [-98.632, 78.872],
          [-97.337, 78.832],
          [-96.754, 78.766],
          [-95.559, 78.418],
          [-95.83, 78.057],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-100.06, 78.325],
          [-99.671, 77.908],
          [-101.304, 78.019],
          [-102.95, 78.343],
          [-105.176, 78.38],
          [-104.21, 78.677],
          [-105.42, 78.918],
          [-105.492, 79.302],
          [-103.529, 79.165],
          [-100.825, 78.8],
          [-100.06, 78.325],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-109.663, 78.602],
          [-110.881, 78.407],
          [-112.542, 78.408],
          [-112.526, 78.551],
          [-111.5, 78.85],
          [-110.964, 78.804],
          [-109.663, 78.602],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-95.648, 69.108],
          [-96.27, 68.757],
          [-97.617, 69.06],
          [-98.432, 68.951],
          [-99.797, 69.4],
          [-98.917, 69.71],
          [-98.218, 70.144],
          [-97.157, 69.86],
          [-96.557, 69.68],
          [-96.257, 69.49],
          [-95.648, 69.108],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-178.694, 70.893],
          [-180, 70.832],
          [-180, 71.516],
          [-179.872, 71.558],
          [-179.024, 71.556],
          [-177.578, 71.269],
          [-177.664, 71.133],
          [-178.694, 70.893],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-120.46, 71.4],
          [-123.092, 70.902],
          [-123.62, 71.34],
          [-125.929, 71.869],
          [-125.593, 72.195],
          [-124.807, 73.023],
          [-123.94, 73.68],
          [-124.918, 74.293],
          [-121.538, 74.449],
          [-120.11, 74.241],
          [-117.556, 74.186],
          [-116.584, 73.896],
          [-115.511, 73.475],
          [-116.768, 73.223],
          [-119.22, 72.52],
          [-120.46, 71.82],
          [-120.46, 71.4],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-100.356, 73.844],
          [-99.164, 73.633],
          [-97.38, 73.76],
          [-97.12, 73.47],
          [-98.054, 72.991],
          [-96.54, 72.56],
          [-96.72, 71.66],
          [-98.36, 71.273],
          [-99.323, 71.356],
          [-100.015, 71.738],
          [-102.5, 72.51],
          [-102.48, 72.83],
          [-100.438, 72.706],
          [-101.54, 73.36],
          [-100.356, 73.844],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-94.684, 77.098],
          [-93.574, 76.776],
          [-91.605, 76.779],
          [-90.742, 76.45],
          [-90.97, 76.074],
          [-89.822, 75.848],
          [-89.187, 75.61],
          [-87.838, 75.566],
          [-86.379, 75.482],
          [-84.79, 75.699],
          [-82.753, 75.784],
          [-81.129, 75.714],
          [-80.058, 75.337],
          [-79.834, 74.923],
          [-80.458, 74.657],
          [-81.949, 74.442],
          [-83.229, 74.564],
          [-86.097, 74.41],
          [-88.15, 74.392],
          [-89.765, 74.516],
          [-92.422, 74.838],
          [-92.768, 75.387],
          [-92.89, 75.883],
          [-93.894, 76.319],
          [-95.962, 76.441],
          [-97.121, 76.751],
          [-96.745, 77.161],
          [-94.684, 77.098],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [[[-104.5, 73.42], [-105.38, 72.76], [-106.94, 73.46], [-106.6, 73.6], [-105.26, 73.64], [-104.5, 73.42]]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-108.211, 76.202],
          [-107.819, 75.846],
          [-106.929, 76.013],
          [-105.881, 75.969],
          [-105.705, 75.48],
          [-106.313, 75.005],
          [-109.7, 74.85],
          [-112.223, 74.417],
          [-113.744, 74.394],
          [-113.871, 74.72],
          [-111.794, 75.163],
          [-116.312, 75.043],
          [-117.71, 75.222],
          [-116.346, 76.199],
          [-115.405, 76.479],
          [-112.591, 76.141],
          [-110.814, 75.549],
          [-109.067, 75.473],
          [-110.497, 76.43],
          [-109.581, 76.794],
          [-108.549, 76.678],
          [-108.211, 76.202],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-123.51, 48.51],
          [-124.013, 48.371],
          [-125.655, 48.825],
          [-125.955, 49.18],
          [-126.85, 49.53],
          [-127.03, 49.815],
          [-128.059, 49.995],
          [-128.445, 50.539],
          [-128.358, 50.771],
          [-127.309, 50.553],
          [-126.695, 50.401],
          [-125.755, 50.295],
          [-125.415, 49.95],
          [-124.921, 49.475],
          [-123.923, 49.062],
          [-123.51, 48.51],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-132.71, 54.04],
          [-132.71, 54.04],
          [-132.71, 54.04],
          [-132.71, 54.04],
          [-131.75, 54.12],
          [-132.049, 52.985],
          [-131.179, 52.18],
          [-131.578, 52.182],
          [-132.18, 52.64],
          [-132.55, 53.1],
          [-133.055, 53.411],
          [-133.24, 53.851],
          [-133.18, 54.17],
          [-132.71, 54.04],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-171.732, 63.783],
          [-171.114, 63.592],
          [-170.491, 63.695],
          [-169.683, 63.431],
          [-168.689, 63.298],
          [-168.772, 63.189],
          [-169.529, 62.977],
          [-170.291, 63.194],
          [-170.671, 63.376],
          [-171.553, 63.318],
          [-171.791, 63.406],
          [-171.732, 63.783],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-175.014, 66.584],
          [-174.34, 66.336],
          [-174.572, 67.062],
          [-171.857, 66.913],
          [-169.9, 65.977],
          [-170.891, 65.541],
          [-172.53, 65.438],
          [-172.555, 64.461],
          [-172.955, 64.253],
          [-173.892, 64.283],
          [-174.654, 64.631],
          [-175.984, 64.923],
          [-176.207, 65.357],
          [-177.223, 65.52],
          [-178.36, 65.391],
          [-178.903, 65.74],
          [-178.686, 66.112],
          [-179.884, 65.875],
          [-179.433, 65.404],
          [-180, 64.98],
          [-180, 68.964],
          [-177.55, 68.2],
          [-174.928, 67.206],
          [-175.014, 66.584],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-153.006, 57.116],
          [-154.005, 56.735],
          [-154.516, 56.993],
          [-154.671, 57.461],
          [-153.763, 57.817],
          [-153.229, 57.969],
          [-152.565, 57.901],
          [-152.141, 57.591],
          [-153.006, 57.116],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-165.579, 59.91],
          [-166.193, 59.754],
          [-166.848, 59.941],
          [-167.455, 60.213],
          [-166.468, 60.384],
          [-165.674, 60.294],
          [-165.579, 59.91],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-114.167, 73.121],
          [-114.666, 72.653],
          [-112.441, 72.955],
          [-111.05, 72.45],
          [-109.92, 72.961],
          [-109.007, 72.633],
          [-108.188, 71.651],
          [-107.686, 72.065],
          [-108.396, 73.09],
          [-107.516, 73.236],
          [-106.523, 73.076],
          [-105.402, 72.673],
          [-104.775, 71.698],
          [-104.465, 70.993],
          [-102.785, 70.498],
          [-100.981, 70.024],
          [-101.089, 69.584],
          [-102.731, 69.504],
          [-102.093, 69.12],
          [-102.43, 68.753],
          [-104.24, 68.91],
          [-105.96, 69.18],
          [-107.123, 69.119],
          [-109, 68.78],
          [-111.967, 68.604],
          [-113.313, 68.536],
          [-113.855, 69.007],
          [-115.22, 69.28],
          [-116.108, 69.168],
          [-117.34, 69.96],
          [-116.675, 70.067],
          [-115.131, 70.237],
          [-113.721, 70.192],
          [-112.416, 70.366],
          [-114.35, 70.6],
          [-116.487, 70.52],
          [-117.905, 70.541],
          [-118.432, 70.909],
          [-116.113, 71.309],
          [-117.656, 71.295],
          [-119.402, 71.559],
          [-118.563, 72.308],
          [-117.866, 72.706],
          [-115.189, 73.315],
          [-114.167, 73.121],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [[[162.119, -10.483], [162.399, -10.826], [161.7, -10.82], [161.32, -10.205], [161.917, -10.447], [162.119, -10.483]]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [[161.68, -9.6], [161.529, -9.784], [160.788, -8.918], [160.58, -8.32], [160.92, -8.32], [161.28, -9.12], [161.68, -9.6]],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [160.852, -9.873],
          [160.463, -9.895],
          [159.849, -9.794],
          [159.64, -9.64],
          [159.703, -9.243],
          [160.363, -9.4],
          [160.689, -9.61],
          [160.852, -9.873],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [159.875, -8.337],
          [159.917, -8.538],
          [159.134, -8.114],
          [158.586, -7.755],
          [158.211, -7.422],
          [158.36, -7.32],
          [158.82, -7.56],
          [159.64, -8.02],
          [159.875, -8.337],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [157.538, -7.348],
          [157.339, -7.405],
          [156.902, -7.177],
          [156.491, -6.766],
          [156.543, -6.599],
          [157.14, -7.022],
          [157.538, -7.348],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [155.88, -6.82],
          [155.6, -6.92],
          [155.167, -6.536],
          [154.729, -5.901],
          [154.514, -5.139],
          [154.653, -5.042],
          [154.76, -5.34],
          [155.063, -5.567],
          [155.548, -6.201],
          [156.02, -6.54],
          [155.88, -6.82],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [151.983, -5.478],
          [151.459, -5.56],
          [151.301, -5.841],
          [150.754, -6.084],
          [150.241, -6.318],
          [149.71, -6.317],
          [148.89, -6.026],
          [148.319, -5.747],
          [148.402, -5.438],
          [149.298, -5.584],
          [149.846, -5.506],
          [149.996, -5.026],
          [150.14, -5.001],
          [150.237, -5.532],
          [150.807, -5.456],
          [151.09, -5.114],
          [151.648, -4.757],
          [151.538, -4.168],
          [152.137, -4.149],
          [152.339, -4.313],
          [152.319, -4.868],
          [151.983, -5.478],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [153.14, -4.5],
          [152.827, -4.766],
          [152.639, -4.176],
          [152.406, -3.79],
          [151.953, -3.462],
          [151.384, -3.035],
          [150.662, -2.741],
          [150.94, -2.5],
          [151.48, -2.78],
          [151.82, -3],
          [152.24, -3.24],
          [152.64, -3.66],
          [153.02, -3.98],
          [153.14, -4.5],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [145.398, -40.793],
          [146.364, -41.138],
          [146.909, -41.001],
          [147.689, -40.808],
          [148.289, -40.875],
          [148.36, -42.062],
          [148.017, -42.407],
          [147.914, -43.212],
          [147.565, -42.938],
          [146.87, -43.635],
          [146.663, -43.581],
          [146.048, -43.55],
          [145.432, -42.694],
          [145.295, -42.034],
          [144.718, -41.163],
          [144.744, -40.704],
          [145.398, -40.793],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [173.02, -40.919],
          [173.247, -41.332],
          [173.958, -40.927],
          [174.248, -41.349],
          [174.249, -41.77],
          [173.876, -42.233],
          [173.223, -42.97],
          [172.711, -43.372],
          [173.08, -43.853],
          [172.309, -43.866],
          [171.453, -44.243],
          [171.185, -44.897],
          [170.617, -45.909],
          [169.831, -46.356],
          [169.332, -46.641],
          [168.411, -46.62],
          [167.764, -46.29],
          [166.677, -46.22],
          [166.509, -45.853],
          [167.046, -45.111],
          [168.304, -44.124],
          [168.949, -43.936],
          [169.668, -43.555],
          [170.525, -43.032],
          [171.125, -42.513],
          [171.57, -41.767],
          [171.949, -41.514],
          [172.097, -40.956],
          [172.799, -40.494],
          [173.02, -40.919],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [174.612, -36.156],
          [175.337, -37.209],
          [175.358, -36.526],
          [175.809, -36.799],
          [175.958, -37.555],
          [176.763, -37.881],
          [177.439, -37.961],
          [178.01, -37.58],
          [178.517, -37.695],
          [178.275, -38.583],
          [177.97, -39.166],
          [177.207, -39.146],
          [176.94, -39.45],
          [177.033, -39.88],
          [176.886, -40.066],
          [176.508, -40.605],
          [176.012, -41.29],
          [175.24, -41.688],
          [175.068, -41.426],
          [174.651, -41.282],
          [175.228, -40.459],
          [174.9, -39.909],
          [173.824, -39.509],
          [173.852, -39.147],
          [174.575, -38.798],
          [174.743, -38.028],
          [174.697, -37.381],
          [174.292, -36.711],
          [174.319, -36.535],
          [173.841, -36.122],
          [173.054, -35.237],
          [172.636, -34.529],
          [173.007, -34.451],
          [173.551, -35.006],
          [174.329, -35.265],
          [174.612, -36.156],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [167.12, -22.16],
          [166.74, -22.4],
          [166.19, -22.13],
          [165.474, -21.68],
          [164.83, -21.15],
          [164.168, -20.445],
          [164.03, -20.106],
          [164.46, -20.12],
          [165.02, -20.46],
          [165.46, -20.8],
          [165.78, -21.08],
          [166.6, -21.7],
          [167.12, -22.16],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [178.374, -17.34],
          [178.718, -17.628],
          [178.553, -18.151],
          [177.933, -18.288],
          [177.381, -18.164],
          [177.285, -17.725],
          [177.671, -17.381],
          [178.126, -17.505],
          [178.374, -17.34],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [179.364, -16.801],
          [178.725, -17.012],
          [178.597, -16.639],
          [179.097, -16.434],
          [179.414, -16.379],
          [180, -16.067],
          [180, -16.555],
          [179.364, -16.801],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [[[167.845, -16.466], [167.515, -16.598], [167.18, -16.16], [167.217, -15.892], [167.845, -16.466]]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [167.108, -14.934],
          [167.27, -15.74],
          [167.001, -15.615],
          [166.793, -15.669],
          [166.65, -15.393],
          [166.629, -14.626],
          [167.108, -14.934],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [81.218, 6.197],
          [80.348, 5.968],
          [79.872, 6.763],
          [79.695, 8.201],
          [80.148, 9.824],
          [80.839, 9.268],
          [81.304, 8.564],
          [81.788, 7.523],
          [81.637, 6.482],
          [81.218, 6.197],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [118.505, 9.316],
          [117.174, 8.367],
          [117.664, 9.067],
          [118.387, 9.684],
          [118.987, 10.376],
          [119.511, 11.37],
          [119.69, 10.554],
          [119.029, 10.004],
          [118.505, 9.316],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [123.982, 10.279],
          [123.623, 9.95],
          [123.31, 9.318],
          [122.996, 9.022],
          [122.38, 9.713],
          [122.586, 9.981],
          [122.837, 10.261],
          [122.947, 10.882],
          [123.499, 10.941],
          [123.338, 10.267],
          [124.078, 11.233],
          [123.982, 10.279],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [125.503, 12.163],
          [125.783, 11.046],
          [125.012, 11.311],
          [125.033, 10.976],
          [125.277, 10.359],
          [124.802, 10.135],
          [124.76, 10.838],
          [124.459, 10.89],
          [124.303, 11.495],
          [124.891, 11.416],
          [124.878, 11.794],
          [124.267, 12.558],
          [125.227, 12.536],
          [125.503, 12.163],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [121.884, 11.892],
          [122.484, 11.582],
          [123.12, 11.584],
          [123.101, 11.166],
          [122.638, 10.741],
          [122.003, 10.441],
          [121.967, 10.906],
          [122.038, 11.416],
          [121.884, 11.892],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [[[121.527, 13.07], [121.262, 12.206], [120.834, 12.704], [120.323, 13.466], [121.18, 13.43], [121.527, 13.07]]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [110.339, 18.678],
          [109.475, 18.198],
          [108.655, 18.508],
          [108.626, 19.368],
          [109.119, 19.821],
          [110.212, 20.101],
          [110.787, 20.078],
          [111.01, 19.696],
          [110.571, 19.256],
          [110.339, 18.678],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [121.321, 18.504],
          [121.938, 18.219],
          [122.246, 18.479],
          [122.337, 18.225],
          [122.174, 17.81],
          [122.516, 17.094],
          [122.252, 16.262],
          [121.663, 15.931],
          [121.505, 15.125],
          [121.729, 14.328],
          [122.259, 14.218],
          [122.701, 14.337],
          [123.95, 13.782],
          [123.855, 13.238],
          [124.181, 12.998],
          [124.077, 12.537],
          [123.298, 13.028],
          [122.929, 13.553],
          [122.671, 13.186],
          [122.035, 13.784],
          [121.126, 13.637],
          [120.629, 13.858],
          [120.679, 14.271],
          [120.992, 14.525],
          [120.693, 14.757],
          [120.564, 14.396],
          [120.07, 14.971],
          [119.921, 15.406],
          [119.884, 16.364],
          [120.286, 16.035],
          [120.39, 17.599],
          [120.716, 18.505],
          [121.321, 18.504],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [[134.725, -6.214], [134.21, -6.895], [134.113, -6.142], [134.29, -5.783], [134.5, -5.445], [134.727, -5.738], [134.725, -6.214]],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [105.818, -5.852],
          [104.71, -5.873],
          [103.868, -5.037],
          [102.584, -4.22],
          [102.156, -3.614],
          [101.399, -2.8],
          [100.903, -2.05],
          [100.142, -0.65],
          [99.264, 0.183],
          [98.97, 1.043],
          [98.601, 1.824],
          [97.7, 2.453],
          [97.177, 3.309],
          [96.424, 3.869],
          [95.381, 4.971],
          [95.293, 5.48],
          [95.937, 5.44],
          [97.485, 5.246],
          [98.369, 4.268],
          [99.143, 3.59],
          [99.694, 3.174],
          [100.641, 2.099],
          [101.658, 2.084],
          [102.498, 1.399],
          [103.077, 0.561],
          [103.838, 0.105],
          [103.438, -0.712],
          [104.011, -1.059],
          [104.37, -1.085],
          [104.539, -1.782],
          [104.888, -2.34],
          [105.622, -2.429],
          [106.109, -3.062],
          [105.857, -4.306],
          [105.818, -5.852],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [[[127.249, -3.459], [126.875, -3.791], [126.184, -3.607], [125.989, -3.177], [127.001, -3.129], [127.249, -3.459]]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [117.876, 1.828],
          [118.997, 0.902],
          [117.812, 0.784],
          [117.478, 0.102],
          [117.522, -0.804],
          [116.56, -1.488],
          [116.534, -2.484],
          [116.148, -4.013],
          [116.001, -3.657],
          [114.865, -4.107],
          [114.469, -3.496],
          [113.756, -3.439],
          [113.257, -3.119],
          [112.068, -3.478],
          [111.703, -2.994],
          [111.048, -3.049],
          [110.224, -2.934],
          [110.071, -1.593],
          [109.572, -1.315],
          [109.092, -0.46],
          [108.953, 0.415],
          [109.069, 1.342],
          [109.663, 2.006],
          [110.396, 1.664],
          [111.169, 1.851],
          [111.37, 2.697],
          [111.797, 2.886],
          [112.996, 3.102],
          [113.713, 3.894],
          [114.204, 4.526],
          [114.6, 4.9],
          [115.451, 5.448],
          [116.221, 6.143],
          [116.725, 6.925],
          [117.13, 6.928],
          [117.643, 6.422],
          [117.689, 5.987],
          [118.348, 5.709],
          [119.182, 5.408],
          [119.111, 5.016],
          [118.44, 4.967],
          [118.618, 4.478],
          [117.882, 4.138],
          [117.313, 3.234],
          [118.048, 2.288],
          [117.876, 1.828],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [130.471, -3.094],
          [130.835, -3.858],
          [129.991, -3.446],
          [129.155, -3.363],
          [128.591, -3.429],
          [127.899, -3.393],
          [128.136, -2.844],
          [129.371, -2.802],
          [130.471, -3.094],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [125.241, 1.42],
          [124.437, 0.428],
          [123.686, 0.236],
          [122.723, 0.431],
          [121.057, 0.381],
          [120.183, 0.237],
          [120.041, -0.52],
          [120.936, -1.409],
          [121.476, -0.956],
          [123.341, -0.616],
          [123.258, -1.076],
          [122.823, -0.931],
          [122.389, -1.517],
          [121.508, -1.904],
          [122.455, -3.186],
          [122.272, -3.53],
          [123.171, -4.684],
          [123.162, -5.341],
          [122.629, -5.635],
          [122.236, -5.283],
          [122.72, -4.464],
          [121.738, -4.851],
          [121.489, -4.575],
          [121.619, -4.188],
          [120.898, -3.602],
          [120.972, -2.628],
          [120.305, -2.932],
          [120.39, -4.098],
          [120.431, -5.528],
          [119.797, -5.673],
          [119.367, -5.38],
          [119.654, -4.459],
          [119.499, -3.494],
          [119.078, -3.487],
          [118.768, -2.802],
          [119.181, -2.147],
          [119.323, -1.353],
          [119.826, 0.154],
          [120.036, 0.566],
          [120.886, 1.309],
          [121.667, 1.014],
          [122.928, 0.875],
          [124.078, 0.917],
          [125.066, 1.643],
          [125.241, 1.42],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [128.688, 1.132],
          [128.636, 0.258],
          [128.12, 0.356],
          [127.968, -0.252],
          [128.38, -0.78],
          [128.1, -0.9],
          [127.696, -0.267],
          [127.399, 1.012],
          [127.601, 1.811],
          [127.932, 2.175],
          [128.004, 1.629],
          [128.595, 1.541],
          [128.688, 1.132],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [126.377, 8.415],
          [126.479, 7.75],
          [126.537, 7.189],
          [126.197, 6.274],
          [125.831, 7.294],
          [125.364, 6.786],
          [125.683, 6.05],
          [125.397, 5.581],
          [124.22, 6.161],
          [123.939, 6.885],
          [124.244, 7.361],
          [123.61, 7.834],
          [123.296, 7.419],
          [122.826, 7.457],
          [122.085, 6.899],
          [121.92, 7.192],
          [122.312, 8.035],
          [122.942, 8.316],
          [123.488, 8.693],
          [123.841, 8.24],
          [124.601, 8.514],
          [124.765, 8.96],
          [125.471, 8.987],
          [125.412, 9.76],
          [126.223, 9.286],
          [126.307, 8.782],
          [126.377, 8.415],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [[120.716, -10.24], [120.295, -10.259], [118.968, -9.558], [119.9, -9.361], [120.426, -9.666], [120.776, -9.97], [120.716, -10.24]],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [143.562, -13.764],
          [143.922, -14.548],
          [144.564, -14.171],
          [144.895, -14.594],
          [145.375, -14.985],
          [145.272, -15.428],
          [145.485, -16.286],
          [145.637, -16.785],
          [145.889, -16.907],
          [146.16, -17.762],
          [146.064, -18.28],
          [146.387, -18.958],
          [147.471, -19.481],
          [148.178, -19.956],
          [148.848, -20.391],
          [148.717, -20.633],
          [149.289, -21.261],
          [149.678, -22.343],
          [150.077, -22.123],
          [150.483, -22.556],
          [150.727, -22.402],
          [150.9, -23.462],
          [151.609, -24.076],
          [152.074, -24.458],
          [152.855, -25.268],
          [153.136, -26.071],
          [153.162, -26.641],
          [153.093, -27.26],
          [153.569, -28.11],
          [153.512, -28.995],
          [153.339, -29.458],
          [153.069, -30.35],
          [153.09, -30.924],
          [152.892, -31.64],
          [152.45, -32.55],
          [151.709, -33.041],
          [151.344, -33.816],
          [151.011, -34.31],
          [150.714, -35.173],
          [150.328, -35.672],
          [150.075, -36.42],
          [149.946, -37.109],
          [149.997, -37.425],
          [149.424, -37.773],
          [148.305, -37.809],
          [147.382, -38.219],
          [146.922, -38.607],
          [146.318, -39.036],
          [145.49, -38.594],
          [144.877, -38.417],
          [145.032, -37.896],
          [144.486, -38.085],
          [143.61, -38.809],
          [142.745, -38.538],
          [142.178, -38.38],
          [141.607, -38.309],
          [140.639, -38.019],
          [139.992, -37.403],
          [139.807, -36.644],
          [139.574, -36.138],
          [139.083, -35.733],
          [138.121, -35.612],
          [138.449, -35.127],
          [138.208, -34.385],
          [137.719, -35.077],
          [136.829, -35.261],
          [137.352, -34.707],
          [137.504, -34.13],
          [137.89, -33.64],
          [137.81, -32.9],
          [136.997, -33.753],
          [136.372, -34.095],
          [135.989, -34.89],
          [135.208, -34.479],
          [135.239, -33.948],
          [134.613, -33.223],
          [134.086, -32.848],
          [134.274, -32.617],
          [132.991, -32.011],
          [132.288, -31.983],
          [131.326, -31.496],
          [129.536, -31.59],
          [128.241, -31.948],
          [127.103, -32.282],
          [126.149, -32.216],
          [125.089, -32.729],
          [124.222, -32.959],
          [124.029, -33.484],
          [123.66, -33.89],
          [122.811, -33.914],
          [122.183, -34.003],
          [121.299, -33.821],
          [120.58, -33.93],
          [119.894, -33.976],
          [119.299, -34.509],
          [119.007, -34.464],
          [118.506, -34.747],
          [118.025, -35.065],
          [117.296, -35.025],
          [116.625, -35.025],
          [115.564, -34.386],
          [115.027, -34.197],
          [115.049, -33.623],
          [115.545, -33.487],
          [115.715, -33.26],
          [115.679, -32.9],
          [115.802, -32.205],
          [115.69, -31.612],
          [115.161, -30.602],
          [114.997, -30.031],
          [115.04, -29.461],
          [114.642, -28.81],
          [114.616, -28.516],
          [114.174, -28.118],
          [114.049, -27.335],
          [113.477, -26.543],
          [113.339, -26.117],
          [113.778, -26.549],
          [113.441, -25.621],
          [113.937, -25.911],
          [114.233, -26.298],
          [114.216, -25.786],
          [113.721, -24.999],
          [113.625, -24.684],
          [113.394, -24.385],
          [113.502, -23.806],
          [113.707, -23.56],
          [113.843, -23.06],
          [113.737, -22.475],
          [114.15, -21.756],
          [114.225, -22.517],
          [114.648, -21.83],
          [115.46, -21.495],
          [115.947, -21.069],
          [116.712, -20.702],
          [117.166, -20.624],
          [117.442, -20.747],
          [118.23, -20.374],
          [118.836, -20.263],
          [118.988, -20.044],
          [119.252, -19.953],
          [119.805, -19.977],
          [120.856, -19.684],
          [121.4, -19.24],
          [121.655, -18.705],
          [122.242, -18.198],
          [122.287, -17.799],
          [122.313, -17.255],
          [123.013, -16.405],
          [123.434, -17.269],
          [123.859, -17.069],
          [123.503, -16.597],
          [123.817, -16.111],
          [124.258, -16.328],
          [124.38, -15.567],
          [124.926, -15.075],
          [125.167, -14.68],
          [125.67, -14.51],
          [125.686, -14.231],
          [126.125, -14.347],
          [126.143, -14.096],
          [126.583, -13.953],
          [127.066, -13.818],
          [127.805, -14.277],
          [128.36, -14.869],
          [128.986, -14.876],
          [129.621, -14.97],
          [129.41, -14.421],
          [129.889, -13.619],
          [130.339, -13.357],
          [130.184, -13.108],
          [130.618, -12.536],
          [131.223, -12.184],
          [131.735, -12.302],
          [132.575, -12.114],
          [132.557, -11.603],
          [131.825, -11.274],
          [132.357, -11.129],
          [133.02, -11.376],
          [133.551, -11.787],
          [134.393, -12.042],
          [134.679, -11.941],
          [135.298, -12.249],
          [135.883, -11.962],
          [136.258, -12.049],
          [136.492, -11.857],
          [136.952, -12.352],
          [136.685, -12.887],
          [136.305, -13.291],
          [135.962, -13.325],
          [136.078, -13.724],
          [135.784, -14.224],
          [135.429, -14.715],
          [135.5, -14.998],
          [136.295, -15.55],
          [137.065, -15.871],
          [137.58, -16.215],
          [138.303, -16.808],
          [138.585, -16.807],
          [139.109, -17.063],
          [139.261, -17.372],
          [140.215, -17.711],
          [140.875, -17.369],
          [141.071, -16.832],
          [141.274, -16.389],
          [141.398, -15.841],
          [141.702, -15.045],
          [141.563, -14.561],
          [141.636, -14.27],
          [141.52, -13.698],
          [141.651, -12.945],
          [141.843, -12.742],
          [141.687, -12.408],
          [141.929, -11.877],
          [142.118, -11.328],
          [142.144, -11.043],
          [142.515, -10.668],
          [142.797, -11.157],
          [142.867, -11.785],
          [143.116, -11.906],
          [143.159, -12.326],
          [143.522, -12.834],
          [143.597, -13.4],
          [143.562, -13.764],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [134.143, -1.152],
          [134.423, -2.769],
          [135.458, -3.368],
          [136.293, -2.307],
          [137.441, -1.704],
          [138.33, -1.703],
          [139.185, -2.051],
          [139.927, -2.409],
          [141, -2.6],
          [142.735, -3.289],
          [144.584, -3.861],
          [145.273, -4.374],
          [145.83, -4.876],
          [145.982, -5.466],
          [147.648, -6.084],
          [147.891, -6.614],
          [146.971, -6.722],
          [147.192, -7.388],
          [148.085, -8.044],
          [148.734, -9.105],
          [149.307, -9.071],
          [149.267, -9.514],
          [150.039, -9.684],
          [149.739, -9.873],
          [150.802, -10.294],
          [150.691, -10.583],
          [150.028, -10.652],
          [149.782, -10.393],
          [148.923, -10.281],
          [147.913, -10.13],
          [147.135, -9.492],
          [146.568, -8.943],
          [146.048, -8.067],
          [144.744, -7.63],
          [143.897, -7.915],
          [143.286, -8.245],
          [143.414, -8.983],
          [142.628, -9.327],
          [142.068, -9.16],
          [141.034, -9.118],
          [140.143, -8.297],
          [139.128, -8.096],
          [138.881, -8.381],
          [137.614, -8.412],
          [138.039, -7.598],
          [138.669, -7.32],
          [138.408, -6.233],
          [137.928, -5.393],
          [135.989, -4.547],
          [135.165, -4.463],
          [133.663, -3.539],
          [133.368, -4.025],
          [132.984, -4.113],
          [132.757, -3.746],
          [132.754, -3.312],
          [131.99, -2.821],
          [133.067, -2.46],
          [133.78, -2.48],
          [133.696, -2.215],
          [132.232, -2.213],
          [131.836, -1.617],
          [130.943, -1.433],
          [130.52, -0.938],
          [131.868, -0.695],
          [132.38, -0.37],
          [133.986, -0.78],
          [134.143, -1.152],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [70.28, -49.71],
          [68.745, -49.775],
          [68.72, -49.242],
          [68.868, -48.83],
          [68.935, -48.625],
          [69.58, -48.94],
          [70.525, -49.065],
          [70.56, -49.255],
          [70.28, -49.71],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [124.436, -10.14],
          [123.58, -10.36],
          [123.46, -10.24],
          [123.55, -9.9],
          [123.98, -9.29],
          [124.969, -8.893],
          [125.086, -8.657],
          [125.947, -8.432],
          [126.645, -8.398],
          [126.957, -8.273],
          [127.336, -8.397],
          [126.968, -8.668],
          [125.926, -9.106],
          [125.089, -9.393],
          [124.436, -10.14],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [122.904, -8.094],
          [122.757, -8.65],
          [121.254, -8.934],
          [119.924, -8.81],
          [119.921, -8.445],
          [120.715, -8.237],
          [121.342, -8.537],
          [122.007, -8.461],
          [122.904, -8.094],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [117.9, -8.096],
          [118.261, -8.362],
          [118.878, -8.281],
          [119.127, -8.706],
          [117.97, -8.907],
          [117.278, -9.041],
          [116.74, -9.033],
          [117.084, -8.457],
          [117.632, -8.449],
          [117.9, -8.096],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [108.623, -6.778],
          [110.539, -6.877],
          [110.76, -6.465],
          [112.615, -6.946],
          [112.979, -7.594],
          [114.479, -7.777],
          [115.706, -8.371],
          [114.565, -8.752],
          [113.465, -8.349],
          [112.56, -8.376],
          [111.522, -8.302],
          [110.586, -8.123],
          [109.428, -7.741],
          [108.694, -7.642],
          [108.278, -7.767],
          [106.454, -7.355],
          [106.281, -6.925],
          [105.365, -6.851],
          [106.052, -5.896],
          [107.265, -5.955],
          [108.072, -6.346],
          [108.487, -6.422],
          [108.623, -6.778],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-76.903, 17.868],
          [-77.206, 17.701],
          [-77.766, 17.862],
          [-78.338, 18.226],
          [-78.218, 18.455],
          [-77.797, 18.524],
          [-77.57, 18.491],
          [-76.897, 18.401],
          [-76.365, 18.161],
          [-76.2, 17.887],
          [-76.903, 17.868],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-65.591, 18.228],
          [-65.847, 17.976],
          [-66.6, 17.982],
          [-67.184, 17.947],
          [-67.242, 18.374],
          [-67.101, 18.521],
          [-66.282, 18.515],
          [-65.771, 18.427],
          [-65.591, 18.228],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-155.542, 19.083],
          [-155.688, 18.916],
          [-155.937, 19.059],
          [-155.908, 19.339],
          [-156.073, 19.703],
          [-156.024, 19.814],
          [-155.85, 19.977],
          [-155.919, 20.174],
          [-155.861, 20.267],
          [-155.785, 20.249],
          [-155.402, 20.08],
          [-155.225, 19.993],
          [-155.062, 19.859],
          [-154.807, 19.509],
          [-154.831, 19.453],
          [-155.222, 19.24],
          [-155.542, 19.083],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-79.68, 22.765],
          [-79.281, 22.399],
          [-78.347, 22.512],
          [-77.993, 22.277],
          [-77.146, 21.658],
          [-76.524, 21.207],
          [-76.195, 21.221],
          [-75.598, 21.017],
          [-75.671, 20.735],
          [-74.934, 20.694],
          [-74.178, 20.285],
          [-74.297, 20.05],
          [-74.962, 19.923],
          [-75.635, 19.874],
          [-76.324, 19.953],
          [-77.755, 19.855],
          [-77.085, 20.413],
          [-77.493, 20.673],
          [-78.137, 20.74],
          [-78.483, 21.029],
          [-78.72, 21.598],
          [-79.285, 21.559],
          [-80.217, 21.827],
          [-80.518, 22.037],
          [-81.821, 22.192],
          [-82.17, 22.387],
          [-81.795, 22.637],
          [-82.776, 22.688],
          [-83.494, 22.169],
          [-83.909, 22.155],
          [-84.052, 21.911],
          [-84.547, 21.801],
          [-84.975, 21.896],
          [-84.447, 22.205],
          [-84.23, 22.566],
          [-83.778, 22.788],
          [-83.268, 22.983],
          [-82.51, 23.079],
          [-82.268, 23.189],
          [-81.404, 23.117],
          [-80.619, 23.106],
          [-79.68, 22.765],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-157.653, 21.322],
          [-157.707, 21.264],
          [-157.779, 21.277],
          [-158.127, 21.312],
          [-158.254, 21.539],
          [-158.293, 21.579],
          [-158.025, 21.717],
          [-157.942, 21.653],
          [-157.653, 21.322],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-156.079, 20.644],
          [-156.414, 20.572],
          [-156.587, 20.783],
          [-156.702, 20.864],
          [-156.711, 20.927],
          [-156.613, 21.012],
          [-156.257, 20.917],
          [-155.996, 20.764],
          [-156.079, 20.644],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-159.345, 21.982],
          [-159.464, 21.883],
          [-159.801, 22.065],
          [-159.749, 22.138],
          [-159.596, 22.236],
          [-159.366, 22.215],
          [-159.345, 21.982],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [[[-156.758, 21.177], [-156.789, 21.069], [-157.325, 21.098], [-157.25, 21.22], [-156.758, 21.177]]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-67.75, -53.85],
          [-66.45, -54.45],
          [-65.05, -54.7],
          [-65.5, -55.2],
          [-66.45, -55.25],
          [-66.96, -54.897],
          [-67.291, -55.301],
          [-68.149, -55.612],
          [-69.232, -55.499],
          [-69.958, -55.198],
          [-71.006, -55.054],
          [-72.264, -54.495],
          [-73.285, -53.958],
          [-74.663, -52.837],
          [-73.838, -53.047],
          [-72.434, -53.715],
          [-71.108, -54.074],
          [-70.592, -53.616],
          [-70.267, -52.931],
          [-69.346, -52.518],
          [-68.634, -52.636],
          [-68.634, -52.636],
          [-68.25, -53.1],
          [-67.75, -53.85],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-90.547, 69.498],
          [-90.552, 68.475],
          [-89.215, 69.259],
          [-88.02, 68.615],
          [-88.318, 67.873],
          [-87.35, 67.199],
          [-86.306, 67.922],
          [-85.577, 68.784],
          [-85.522, 69.882],
          [-84.101, 69.805],
          [-82.622, 69.658],
          [-81.28, 69.162],
          [-81.22, 68.666],
          [-81.964, 68.133],
          [-81.259, 67.597],
          [-81.386, 67.111],
          [-83.344, 66.412],
          [-84.735, 66.257],
          [-85.769, 66.558],
          [-86.068, 66.056],
          [-87.031, 65.213],
          [-87.323, 64.776],
          [-88.483, 64.099],
          [-89.914, 64.033],
          [-90.704, 63.61],
          [-90.77, 62.96],
          [-91.933, 62.835],
          [-93.157, 62.025],
          [-94.242, 60.899],
          [-94.629, 60.11],
          [-94.685, 58.949],
          [-93.215, 58.782],
          [-92.765, 57.846],
          [-92.297, 57.087],
          [-90.898, 57.285],
          [-89.039, 56.852],
          [-88.04, 56.472],
          [-87.324, 55.999],
          [-86.071, 55.724],
          [-85.012, 55.303],
          [-83.36, 55.245],
          [-82.273, 55.148],
          [-82.436, 54.282],
          [-82.125, 53.277],
          [-81.401, 52.158],
          [-79.913, 51.208],
          [-79.143, 51.534],
          [-78.602, 52.562],
          [-79.124, 54.141],
          [-79.83, 54.668],
          [-78.229, 55.136],
          [-77.096, 55.838],
          [-76.541, 56.534],
          [-76.623, 57.203],
          [-77.302, 58.052],
          [-78.517, 58.805],
          [-77.337, 59.853],
          [-77.773, 60.758],
          [-78.107, 62.32],
          [-77.411, 62.55],
          [-75.696, 62.279],
          [-74.668, 62.181],
          [-73.84, 62.444],
          [-72.909, 62.105],
          [-71.677, 61.525],
          [-71.374, 61.137],
          [-69.59, 61.062],
          [-69.62, 60.221],
          [-69.288, 58.957],
          [-68.375, 58.801],
          [-67.65, 58.212],
          [-66.202, 58.767],
          [-65.245, 59.871],
          [-64.583, 60.336],
          [-63.805, 59.443],
          [-62.502, 58.167],
          [-61.396, 56.968],
          [-61.799, 56.339],
          [-60.469, 55.776],
          [-59.57, 55.204],
          [-57.975, 54.945],
          [-57.333, 54.627],
          [-56.937, 53.78],
          [-56.158, 53.648],
          [-55.756, 53.271],
          [-55.683, 52.147],
          [-56.409, 51.771],
          [-57.127, 51.42],
          [-58.775, 51.064],
          [-60.033, 50.243],
          [-61.724, 50.081],
          [-63.862, 50.291],
          [-65.363, 50.298],
          [-66.399, 50.229],
          [-67.236, 49.511],
          [-68.511, 49.068],
          [-69.954, 47.745],
          [-71.104, 46.822],
          [-70.255, 46.986],
          [-68.65, 48.3],
          [-66.552, 49.133],
          [-65.056, 49.233],
          [-64.171, 48.742],
          [-65.115, 48.071],
          [-64.799, 46.993],
          [-64.472, 46.239],
          [-63.173, 45.739],
          [-61.521, 45.884],
          [-60.518, 47.008],
          [-60.449, 46.283],
          [-59.803, 45.92],
          [-61.04, 45.265],
          [-63.255, 44.67],
          [-64.247, 44.266],
          [-65.364, 43.545],
          [-66.123, 43.619],
          [-66.162, 44.465],
          [-64.425, 45.292],
          [-66.026, 45.259],
          [-67.137, 45.138],
          [-66.965, 44.81],
          [-68.032, 44.325],
          [-69.06, 43.98],
          [-70.116, 43.684],
          [-70.69, 43.03],
          [-70.815, 42.865],
          [-70.825, 42.335],
          [-70.495, 41.805],
          [-70.08, 41.78],
          [-70.185, 42.145],
          [-69.885, 41.923],
          [-69.965, 41.637],
          [-70.64, 41.475],
          [-71.12, 41.495],
          [-71.86, 41.32],
          [-72.295, 41.27],
          [-72.876, 41.221],
          [-73.71, 40.931],
          [-72.241, 41.12],
          [-71.945, 40.93],
          [-73.345, 40.63],
          [-73.982, 40.628],
          [-73.952, 40.751],
          [-74.257, 40.474],
          [-73.962, 40.428],
          [-74.178, 39.709],
          [-74.906, 38.94],
          [-74.98, 39.196],
          [-75.2, 39.248],
          [-75.528, 39.498],
          [-75.32, 38.96],
          [-75.083, 38.781],
          [-75.057, 38.404],
          [-75.377, 38.016],
          [-75.94, 37.217],
          [-76.031, 37.257],
          [-75.722, 37.937],
          [-76.233, 38.319],
          [-76.35, 39.15],
          [-76.543, 38.718],
          [-76.329, 38.083],
          [-76.96, 38.233],
          [-76.302, 37.918],
          [-76.259, 36.966],
          [-75.972, 36.897],
          [-75.868, 36.551],
          [-75.727, 35.551],
          [-76.363, 34.808],
          [-77.398, 34.512],
          [-78.055, 33.925],
          [-78.554, 33.861],
          [-79.061, 33.494],
          [-79.203, 33.159],
          [-80.301, 32.509],
          [-80.865, 32.033],
          [-81.336, 31.44],
          [-81.49, 30.73],
          [-81.314, 30.036],
          [-80.98, 29.18],
          [-80.536, 28.472],
          [-80.53, 28.04],
          [-80.057, 26.88],
          [-80.088, 26.206],
          [-80.131, 25.817],
          [-80.381, 25.206],
          [-80.68, 25.08],
          [-81.172, 25.201],
          [-81.33, 25.64],
          [-81.71, 25.87],
          [-82.24, 26.73],
          [-82.705, 27.495],
          [-82.855, 27.886],
          [-82.65, 28.55],
          [-82.93, 29.1],
          [-83.71, 29.937],
          [-84.1, 30.09],
          [-85.109, 29.636],
          [-85.288, 29.686],
          [-85.773, 30.153],
          [-86.4, 30.4],
          [-87.53, 30.274],
          [-88.418, 30.385],
          [-89.18, 30.316],
          [-89.605, 30.176],
          [-89.414, 29.894],
          [-89.43, 29.489],
          [-89.218, 29.291],
          [-89.408, 29.16],
          [-89.779, 29.307],
          [-90.155, 29.117],
          [-90.88, 29.149],
          [-91.627, 29.677],
          [-92.499, 29.552],
          [-93.226, 29.784],
          [-93.848, 29.714],
          [-94.69, 29.48],
          [-95.6, 28.739],
          [-96.594, 28.307],
          [-97.14, 27.83],
          [-97.37, 27.38],
          [-97.38, 26.69],
          [-97.33, 26.21],
          [-97.14, 25.87],
          [-97.139, 25.868],
          [-97.142, 25.866],
          [-97.528, 24.992],
          [-97.703, 24.272],
          [-97.776, 22.933],
          [-97.872, 22.444],
          [-97.699, 21.899],
          [-97.389, 21.411],
          [-97.189, 20.635],
          [-96.526, 19.891],
          [-96.292, 19.32],
          [-95.901, 18.828],
          [-94.839, 18.563],
          [-94.426, 18.144],
          [-93.549, 18.424],
          [-92.786, 18.525],
          [-92.037, 18.705],
          [-91.408, 18.876],
          [-90.772, 19.284],
          [-90.534, 19.867],
          [-90.451, 20.708],
          [-90.279, 21],
          [-89.601, 21.262],
          [-88.544, 21.494],
          [-87.658, 21.459],
          [-87.052, 21.544],
          [-86.812, 21.331],
          [-86.846, 20.85],
          [-87.383, 20.255],
          [-87.621, 19.646],
          [-87.437, 19.472],
          [-87.586, 19.04],
          [-87.837, 18.26],
          [-88.091, 18.517],
          [-88.3, 18.5],
          [-88.296, 18.353],
          [-88.107, 18.349],
          [-88.123, 18.077],
          [-88.285, 17.644],
          [-88.198, 17.49],
          [-88.303, 17.132],
          [-88.24, 17.036],
          [-88.355, 16.531],
          [-88.552, 16.266],
          [-88.732, 16.234],
          [-88.931, 15.887],
          [-88.605, 15.706],
          [-88.518, 15.856],
          [-88.225, 15.728],
          [-88.121, 15.689],
          [-87.902, 15.865],
          [-87.616, 15.879],
          [-87.523, 15.797],
          [-87.368, 15.847],
          [-86.903, 15.757],
          [-86.441, 15.783],
          [-86.119, 15.893],
          [-86.002, 16.005],
          [-85.683, 15.954],
          [-85.444, 15.886],
          [-85.182, 15.909],
          [-84.984, 15.996],
          [-84.527, 15.857],
          [-84.368, 15.835],
          [-84.063, 15.648],
          [-83.774, 15.424],
          [-83.41, 15.271],
          [-83.147, 14.996],
          [-83.233, 14.9],
          [-83.284, 14.677],
          [-83.182, 14.311],
          [-83.412, 13.97],
          [-83.52, 13.568],
          [-83.552, 13.127],
          [-83.498, 12.869],
          [-83.473, 12.419],
          [-83.626, 12.321],
          [-83.72, 11.893],
          [-83.651, 11.629],
          [-83.855, 11.373],
          [-83.809, 11.103],
          [-83.656, 10.939],
          [-83.402, 10.396],
          [-83.016, 9.993],
          [-82.546, 9.566],
          [-82.187, 9.208],
          [-82.208, 8.996],
          [-81.809, 8.951],
          [-81.714, 9.032],
          [-81.439, 8.786],
          [-80.947, 8.859],
          [-80.522, 9.111],
          [-79.915, 9.313],
          [-79.573, 9.612],
          [-79.021, 9.553],
          [-79.058, 9.455],
          [-78.501, 9.42],
          [-78.056, 9.248],
          [-77.729, 8.947],
          [-77.353, 8.67],
          [-76.837, 8.639],
          [-76.086, 9.337],
          [-75.675, 9.443],
          [-75.665, 9.774],
          [-75.48, 10.619],
          [-74.907, 11.083],
          [-74.277, 11.102],
          [-74.197, 11.31],
          [-73.415, 11.227],
          [-72.628, 11.732],
          [-72.238, 11.956],
          [-71.754, 12.437],
          [-71.4, 12.376],
          [-71.137, 12.113],
          [-71.332, 11.776],
          [-71.36, 11.54],
          [-71.947, 11.423],
          [-71.621, 10.969],
          [-71.633, 10.446],
          [-72.074, 9.866],
          [-71.696, 9.072],
          [-71.265, 9.137],
          [-71.04, 9.86],
          [-71.35, 10.212],
          [-71.401, 10.969],
          [-70.155, 11.375],
          [-70.294, 11.847],
          [-69.943, 12.162],
          [-69.584, 11.46],
          [-68.883, 11.443],
          [-68.233, 10.886],
          [-68.194, 10.555],
          [-67.296, 10.546],
          [-66.228, 10.649],
          [-65.655, 10.201],
          [-64.89, 10.077],
          [-64.329, 10.39],
          [-64.318, 10.641],
          [-63.079, 10.702],
          [-61.881, 10.716],
          [-62.73, 10.42],
          [-62.388, 9.948],
          [-61.589, 9.873],
          [-60.831, 9.381],
          [-60.671, 8.58],
          [-60.15, 8.603],
          [-59.758, 8.367],
          [-59.102, 7.999],
          [-58.483, 7.348],
          [-58.455, 6.833],
          [-58.078, 6.809],
          [-57.542, 6.321],
          [-57.147, 5.973],
          [-55.949, 5.773],
          [-55.842, 5.953],
          [-55.033, 6.025],
          [-53.958, 5.757],
          [-53.618, 5.646],
          [-52.882, 5.41],
          [-51.823, 4.566],
          [-51.658, 4.156],
          [-51.317, 4.203],
          [-51.07, 3.651],
          [-50.509, 1.901],
          [-49.974, 1.737],
          [-49.947, 1.046],
          [-50.699, 0.223],
          [-50.388, -0.078],
          [-48.62, -0.235],
          [-48.584, -1.238],
          [-47.825, -0.582],
          [-46.567, -0.941],
          [-44.906, -1.552],
          [-44.418, -2.138],
          [-44.582, -2.691],
          [-43.419, -2.383],
          [-41.473, -2.912],
          [-39.979, -2.873],
          [-38.5, -3.701],
          [-37.223, -4.821],
          [-36.453, -5.109],
          [-35.598, -5.149],
          [-35.235, -5.465],
          [-34.896, -6.738],
          [-34.73, -7.343],
          [-35.128, -8.996],
          [-35.637, -9.649],
          [-37.047, -11.041],
          [-37.684, -12.171],
          [-38.424, -13.038],
          [-38.674, -13.058],
          [-38.953, -13.793],
          [-38.882, -15.667],
          [-39.161, -17.208],
          [-39.267, -17.868],
          [-39.583, -18.262],
          [-39.761, -19.599],
          [-40.775, -20.904],
          [-40.945, -21.937],
          [-41.754, -22.371],
          [-41.988, -22.97],
          [-43.075, -22.968],
          [-44.648, -23.352],
          [-45.352, -23.797],
          [-46.472, -24.089],
          [-47.649, -24.885],
          [-48.495, -25.877],
          [-48.641, -26.624],
          [-48.475, -27.176],
          [-48.661, -28.186],
          [-48.888, -28.674],
          [-49.587, -29.224],
          [-50.697, -30.984],
          [-51.576, -31.778],
          [-52.256, -32.245],
          [-52.712, -33.197],
          [-53.374, -33.768],
          [-53.806, -34.397],
          [-54.936, -34.953],
          [-55.674, -34.753],
          [-56.215, -34.86],
          [-57.14, -34.43],
          [-57.818, -34.463],
          [-58.427, -33.909],
          [-58.495, -34.432],
          [-57.226, -35.288],
          [-57.362, -35.977],
          [-56.737, -36.413],
          [-56.788, -36.901],
          [-57.749, -38.184],
          [-59.232, -38.72],
          [-61.237, -38.928],
          [-62.336, -38.828],
          [-62.126, -39.424],
          [-62.331, -40.173],
          [-62.146, -40.677],
          [-62.746, -41.029],
          [-63.771, -41.167],
          [-64.732, -40.803],
          [-65.118, -41.064],
          [-64.979, -42.058],
          [-64.303, -42.359],
          [-63.756, -42.044],
          [-63.458, -42.563],
          [-64.379, -42.873],
          [-65.182, -43.495],
          [-65.329, -44.501],
          [-65.565, -45.037],
          [-66.51, -45.04],
          [-67.294, -45.552],
          [-67.581, -46.302],
          [-66.597, -47.034],
          [-65.641, -47.236],
          [-65.985, -48.133],
          [-67.166, -48.697],
          [-67.816, -49.87],
          [-68.729, -50.264],
          [-69.138, -50.732],
          [-68.815, -51.771],
          [-68.15, -52.35],
          [-68.571, -52.299],
          [-69.461, -52.292],
          [-69.943, -52.538],
          [-70.845, -52.899],
          [-71.006, -53.833],
          [-71.43, -53.856],
          [-72.558, -53.531],
          [-73.703, -52.835],
          [-74.947, -52.263],
          [-75.26, -51.629],
          [-74.977, -51.043],
          [-75.48, -50.378],
          [-75.608, -48.674],
          [-75.183, -47.712],
          [-74.127, -46.939],
          [-75.644, -46.648],
          [-74.692, -45.764],
          [-74.352, -44.103],
          [-73.24, -44.455],
          [-72.718, -42.383],
          [-73.389, -42.117],
          [-73.701, -43.366],
          [-74.332, -43.225],
          [-74.018, -41.795],
          [-73.677, -39.942],
          [-73.218, -39.259],
          [-73.505, -38.283],
          [-73.588, -37.156],
          [-73.167, -37.124],
          [-72.553, -35.509],
          [-71.862, -33.909],
          [-71.438, -32.419],
          [-71.669, -30.921],
          [-71.37, -30.096],
          [-71.49, -28.861],
          [-70.905, -27.64],
          [-70.725, -25.706],
          [-70.404, -23.629],
          [-70.091, -21.393],
          [-70.164, -19.756],
          [-70.372, -18.348],
          [-71.375, -17.774],
          [-71.462, -17.363],
          [-73.445, -16.359],
          [-75.238, -15.266],
          [-76.009, -14.649],
          [-76.423, -13.823],
          [-76.259, -13.535],
          [-77.106, -12.223],
          [-78.092, -10.378],
          [-79.037, -8.387],
          [-79.446, -7.931],
          [-79.76, -7.194],
          [-80.537, -6.542],
          [-81.25, -6.137],
          [-80.926, -5.69],
          [-81.411, -4.737],
          [-81.1, -4.036],
          [-80.302, -3.405],
          [-79.77, -2.657],
          [-79.987, -2.221],
          [-80.369, -2.685],
          [-80.968, -2.247],
          [-80.765, -1.965],
          [-80.934, -1.057],
          [-80.583, -0.907],
          [-80.399, -0.284],
          [-80.021, 0.36],
          [-80.091, 0.768],
          [-79.543, 0.983],
          [-78.855, 1.381],
          [-78.991, 1.691],
          [-78.618, 1.766],
          [-78.662, 2.267],
          [-78.428, 2.63],
          [-77.932, 2.697],
          [-77.51, 3.325],
          [-77.128, 3.85],
          [-77.496, 4.088],
          [-77.308, 4.668],
          [-77.533, 5.583],
          [-77.319, 5.845],
          [-77.477, 6.691],
          [-77.882, 7.224],
          [-78.215, 7.512],
          [-78.429, 8.052],
          [-78.182, 8.319],
          [-78.435, 8.388],
          [-78.622, 8.718],
          [-79.12, 8.996],
          [-79.558, 8.932],
          [-79.76, 8.584],
          [-80.164, 8.333],
          [-80.383, 8.299],
          [-80.481, 8.09],
          [-80.004, 7.547],
          [-80.277, 7.42],
          [-80.421, 7.271],
          [-80.886, 7.221],
          [-81.06, 7.818],
          [-81.19, 7.648],
          [-81.519, 7.707],
          [-81.721, 8.109],
          [-82.131, 8.175],
          [-82.391, 8.292],
          [-82.82, 8.291],
          [-82.851, 8.074],
          [-82.966, 8.225],
          [-83.508, 8.447],
          [-83.711, 8.657],
          [-83.596, 8.831],
          [-83.633, 9.052],
          [-83.91, 9.291],
          [-84.303, 9.487],
          [-84.648, 9.615],
          [-84.713, 9.908],
          [-84.976, 10.087],
          [-84.911, 9.796],
          [-85.111, 9.557],
          [-85.339, 9.834],
          [-85.661, 9.933],
          [-85.797, 10.135],
          [-85.792, 10.439],
          [-85.659, 10.754],
          [-85.942, 10.895],
          [-85.713, 11.089],
          [-86.058, 11.404],
          [-86.526, 11.807],
          [-86.746, 12.144],
          [-87.167, 12.458],
          [-87.669, 12.91],
          [-87.557, 13.065],
          [-87.392, 12.914],
          [-87.317, 12.985],
          [-87.489, 13.297],
          [-87.793, 13.385],
          [-87.904, 13.149],
          [-88.483, 13.164],
          [-88.843, 13.26],
          [-89.257, 13.459],
          [-89.812, 13.521],
          [-90.096, 13.735],
          [-90.609, 13.91],
          [-91.232, 13.928],
          [-91.69, 14.126],
          [-92.228, 14.539],
          [-93.359, 15.615],
          [-93.875, 15.94],
          [-94.692, 16.201],
          [-95.25, 16.128],
          [-96.053, 15.752],
          [-96.557, 15.654],
          [-97.264, 15.917],
          [-98.013, 16.107],
          [-98.948, 16.566],
          [-99.697, 16.706],
          [-100.83, 17.171],
          [-101.666, 17.649],
          [-101.919, 17.916],
          [-102.478, 17.976],
          [-103.501, 18.292],
          [-103.917, 18.749],
          [-104.992, 19.316],
          [-105.493, 19.947],
          [-105.731, 20.434],
          [-105.398, 20.532],
          [-105.501, 20.817],
          [-105.271, 21.076],
          [-105.266, 21.422],
          [-105.603, 21.871],
          [-105.693, 22.269],
          [-106.029, 22.774],
          [-106.91, 23.768],
          [-107.915, 24.549],
          [-108.402, 25.172],
          [-109.26, 25.581],
          [-109.444, 25.825],
          [-109.292, 26.443],
          [-109.801, 26.676],
          [-110.392, 27.162],
          [-110.641, 27.86],
          [-111.179, 27.941],
          [-111.76, 28.468],
          [-112.228, 28.955],
          [-112.272, 29.267],
          [-112.81, 30.021],
          [-113.164, 30.787],
          [-113.149, 31.171],
          [-113.872, 31.568],
          [-114.206, 31.524],
          [-114.776, 31.8],
          [-114.937, 31.393],
          [-114.771, 30.914],
          [-114.674, 30.163],
          [-114.331, 29.75],
          [-113.589, 29.062],
          [-113.424, 28.826],
          [-113.272, 28.755],
          [-113.14, 28.411],
          [-112.962, 28.425],
          [-112.762, 27.78],
          [-112.458, 27.526],
          [-112.245, 27.172],
          [-111.617, 26.663],
          [-111.285, 25.733],
          [-110.988, 25.295],
          [-110.71, 24.826],
          [-110.655, 24.299],
          [-110.173, 24.266],
          [-109.772, 23.811],
          [-109.409, 23.365],
          [-109.433, 23.186],
          [-109.854, 22.818],
          [-110.031, 22.823],
          [-110.295, 23.431],
          [-110.95, 24.001],
          [-111.671, 24.484],
          [-112.182, 24.739],
          [-112.149, 25.47],
          [-112.301, 26.012],
          [-112.777, 26.322],
          [-113.465, 26.768],
          [-113.597, 26.64],
          [-113.849, 26.9],
          [-114.466, 27.142],
          [-115.055, 27.723],
          [-114.982, 27.798],
          [-114.57, 27.742],
          [-114.199, 28.115],
          [-114.162, 28.566],
          [-114.932, 29.279],
          [-115.519, 29.556],
          [-115.887, 30.181],
          [-116.258, 30.836],
          [-116.721, 31.636],
          [-117.128, 32.535],
          [-117.296, 33.046],
          [-117.944, 33.621],
          [-118.411, 33.741],
          [-118.52, 34.028],
          [-119.081, 34.078],
          [-119.439, 34.349],
          [-120.368, 34.447],
          [-120.623, 34.609],
          [-120.744, 35.157],
          [-121.715, 36.162],
          [-122.547, 37.552],
          [-122.512, 37.784],
          [-122.953, 38.114],
          [-123.727, 38.952],
          [-123.865, 39.767],
          [-124.398, 40.313],
          [-124.179, 41.142],
          [-124.214, 42],
          [-124.533, 42.766],
          [-124.142, 43.708],
          [-123.899, 45.523],
          [-124.08, 46.865],
          [-124.396, 47.72],
          [-124.687, 48.185],
          [-124.566, 48.38],
          [-123.12, 48.04],
          [-122.587, 47.096],
          [-122.34, 47.36],
          [-122.5, 48.18],
          [-122.84, 49],
          [-122.974, 49.003],
          [-124.91, 49.985],
          [-125.625, 50.417],
          [-127.436, 50.831],
          [-127.993, 51.716],
          [-127.85, 52.33],
          [-129.13, 52.755],
          [-129.305, 53.562],
          [-130.515, 54.288],
          [-130.536, 54.803],
          [-131.086, 55.179],
          [-131.967, 55.498],
          [-132.25, 56.37],
          [-133.539, 57.179],
          [-134.078, 58.123],
          [-135.038, 58.188],
          [-136.628, 58.212],
          [-137.8, 58.5],
          [-139.868, 59.538],
          [-140.825, 59.727],
          [-142.574, 60.084],
          [-143.959, 59.999],
          [-145.925, 60.459],
          [-147.114, 60.885],
          [-148.224, 60.673],
          [-148.018, 59.978],
          [-148.571, 59.914],
          [-149.728, 59.706],
          [-150.608, 59.368],
          [-151.716, 59.156],
          [-151.859, 59.745],
          [-151.41, 60.726],
          [-150.347, 61.034],
          [-150.621, 61.284],
          [-151.896, 60.727],
          [-152.578, 60.062],
          [-154.019, 59.35],
          [-153.287, 58.865],
          [-154.232, 58.146],
          [-155.307, 57.728],
          [-156.308, 57.423],
          [-156.556, 56.98],
          [-158.117, 56.464],
          [-158.433, 55.994],
          [-159.603, 55.567],
          [-160.29, 55.644],
          [-161.223, 55.365],
          [-162.238, 55.024],
          [-163.069, 54.69],
          [-164.786, 54.404],
          [-164.942, 54.572],
          [-163.848, 55.039],
          [-162.87, 55.348],
          [-161.804, 55.895],
          [-160.564, 56.008],
          [-160.07, 56.418],
          [-158.684, 57.017],
          [-158.461, 57.217],
          [-157.723, 57.57],
          [-157.55, 58.328],
          [-157.042, 58.919],
          [-158.195, 58.616],
          [-158.517, 58.788],
          [-159.059, 58.424],
          [-159.712, 58.932],
          [-159.981, 58.573],
          [-160.355, 59.071],
          [-161.355, 58.671],
          [-161.969, 58.672],
          [-162.055, 59.267],
          [-161.874, 59.634],
          [-162.518, 59.99],
          [-163.818, 59.798],
          [-164.662, 60.268],
          [-165.346, 60.508],
          [-165.351, 61.074],
          [-166.121, 61.5],
          [-165.734, 62.075],
          [-164.919, 62.633],
          [-164.562, 63.146],
          [-163.753, 63.219],
          [-163.067, 63.06],
          [-162.26, 63.542],
          [-161.534, 63.456],
          [-160.773, 63.766],
          [-160.958, 64.223],
          [-161.518, 64.403],
          [-160.778, 64.789],
          [-161.392, 64.777],
          [-162.453, 64.56],
          [-162.758, 64.339],
          [-163.546, 64.559],
          [-164.961, 64.447],
          [-166.425, 64.687],
          [-166.845, 65.089],
          [-168.11, 65.67],
          [-166.705, 66.088],
          [-164.475, 66.577],
          [-163.653, 66.577],
          [-163.789, 66.077],
          [-161.678, 66.116],
          [-162.49, 66.735],
          [-163.72, 67.117],
          [-164.431, 67.616],
          [-165.39, 68.043],
          [-166.764, 68.359],
          [-166.205, 68.883],
          [-164.431, 68.916],
          [-163.169, 69.371],
          [-162.93, 69.858],
          [-161.909, 70.333],
          [-160.935, 70.448],
          [-159.039, 70.892],
          [-158.12, 70.825],
          [-156.581, 71.358],
          [-155.068, 71.148],
          [-154.344, 70.696],
          [-153.9, 70.89],
          [-152.21, 70.83],
          [-152.27, 70.6],
          [-150.74, 70.43],
          [-149.72, 70.53],
          [-147.613, 70.214],
          [-145.69, 70.12],
          [-144.92, 69.99],
          [-143.589, 70.153],
          [-142.073, 69.852],
          [-140.986, 69.712],
          [-139.12, 69.471],
          [-137.546, 68.99],
          [-136.504, 68.898],
          [-135.626, 69.315],
          [-134.415, 69.628],
          [-132.929, 69.505],
          [-131.431, 69.945],
          [-129.795, 70.194],
          [-129.108, 69.779],
          [-128.362, 70.013],
          [-128.138, 70.484],
          [-127.447, 70.377],
          [-125.756, 69.481],
          [-124.425, 70.159],
          [-124.29, 69.4],
          [-123.061, 69.564],
          [-122.683, 69.856],
          [-121.472, 69.798],
          [-119.943, 69.378],
          [-117.603, 69.011],
          [-116.226, 68.841],
          [-115.247, 68.906],
          [-113.898, 68.399],
          [-115.305, 67.903],
          [-113.497, 67.688],
          [-110.798, 67.806],
          [-109.946, 67.981],
          [-108.88, 67.382],
          [-107.792, 67.888],
          [-108.813, 68.312],
          [-108.167, 68.654],
          [-106.95, 68.7],
          [-106.15, 68.8],
          [-105.343, 68.561],
          [-104.338, 68.018],
          [-103.221, 68.098],
          [-101.454, 67.647],
          [-99.902, 67.806],
          [-98.443, 67.782],
          [-98.559, 68.404],
          [-97.669, 68.579],
          [-96.12, 68.24],
          [-96.126, 67.294],
          [-95.489, 68.091],
          [-94.685, 68.064],
          [-94.233, 69.069],
          [-95.304, 69.686],
          [-96.471, 70.09],
          [-96.391, 71.195],
          [-95.209, 71.92],
          [-93.89, 71.76],
          [-92.878, 71.319],
          [-91.52, 70.191],
          [-92.407, 69.7],
          [-90.547, 69.498],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-60.935, 10.11],
          [-61.77, 10],
          [-61.95, 10.09],
          [-61.66, 10.365],
          [-61.68, 10.76],
          [-61.105, 10.89],
          [-60.895, 10.855],
          [-60.935, 10.11],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [[[-179.917, -16.502], [-180, -16.555], [-180, -16.067], [-179.793, -16.021], [-179.917, -16.502]]],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [50.057, -13.556],
          [50.217, -14.759],
          [50.477, -15.227],
          [50.377, -15.706],
          [50.2, -16],
          [49.861, -15.414],
          [49.673, -15.71],
          [49.863, -16.451],
          [49.775, -16.875],
          [49.499, -17.106],
          [49.436, -17.953],
          [49.042, -19.119],
          [48.549, -20.497],
          [47.931, -22.392],
          [47.548, -23.782],
          [47.096, -24.942],
          [46.282, -25.178],
          [45.41, -25.601],
          [44.834, -25.346],
          [44.04, -24.988],
          [43.764, -24.461],
          [43.698, -23.574],
          [43.346, -22.777],
          [43.254, -22.057],
          [43.433, -21.336],
          [43.894, -21.163],
          [43.896, -20.83],
          [44.374, -20.072],
          [44.464, -19.435],
          [44.232, -18.962],
          [44.043, -18.331],
          [43.963, -17.41],
          [44.312, -16.85],
          [44.447, -16.216],
          [44.945, -16.179],
          [45.503, -15.974],
          [45.873, -15.793],
          [46.312, -15.78],
          [46.882, -15.21],
          [47.705, -14.594],
          [48.005, -14.091],
          [47.869, -13.664],
          [48.294, -13.784],
          [48.845, -13.089],
          [48.864, -12.488],
          [49.195, -12.041],
          [49.544, -12.47],
          [49.809, -12.895],
          [50.057, -13.556],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-58.55, -51.1],
          [-57.75, -51.55],
          [-58.05, -51.9],
          [-59.4, -52.2],
          [-59.85, -51.85],
          [-60.7, -52.3],
          [-61.2, -51.85],
          [-60, -51.25],
          [-59.15, -51.5],
          [-58.55, -51.1],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [106.97, 76.974],
          [107.24, 76.48],
          [108.154, 76.723],
          [111.077, 76.71],
          [113.331, 76.222],
          [114.134, 75.848],
          [113.885, 75.328],
          [112.779, 75.032],
          [110.151, 74.477],
          [109.4, 74.18],
          [110.64, 74.04],
          [112.119, 73.788],
          [113.019, 73.977],
          [113.53, 73.335],
          [113.969, 73.595],
          [115.568, 73.753],
          [118.776, 73.588],
          [119.02, 73.12],
          [123.201, 72.971],
          [123.258, 73.735],
          [125.38, 73.56],
          [126.977, 73.565],
          [128.591, 73.039],
          [129.052, 72.399],
          [128.46, 71.98],
          [129.716, 71.193],
          [131.289, 70.787],
          [132.253, 71.836],
          [133.858, 71.386],
          [135.562, 71.655],
          [137.498, 71.348],
          [138.234, 71.628],
          [139.87, 71.488],
          [139.148, 72.416],
          [140.468, 72.849],
          [149.5, 72.2],
          [150.351, 71.607],
          [152.969, 70.842],
          [157.007, 71.031],
          [158.998, 70.867],
          [159.83, 70.453],
          [159.709, 69.722],
          [160.941, 69.437],
          [162.279, 69.642],
          [164.052, 69.668],
          [165.94, 69.472],
          [167.836, 69.583],
          [169.578, 68.694],
          [170.817, 69.014],
          [170.008, 69.653],
          [170.453, 70.097],
          [173.644, 69.818],
          [175.724, 69.877],
          [178.6, 69.4],
          [180, 68.964],
          [180, 64.98],
          [179.993, 64.974],
          [178.707, 64.535],
          [177.411, 64.608],
          [178.313, 64.076],
          [178.908, 63.252],
          [179.37, 62.983],
          [179.487, 62.569],
          [179.228, 62.304],
          [177.364, 62.522],
          [174.569, 61.769],
          [173.68, 61.653],
          [172.15, 60.95],
          [170.698, 60.336],
          [170.331, 59.882],
          [168.901, 60.573],
          [166.295, 59.789],
          [165.84, 60.16],
          [164.877, 59.732],
          [163.539, 59.869],
          [163.217, 59.211],
          [162.017, 58.243],
          [162.053, 57.839],
          [163.192, 57.615],
          [163.058, 56.159],
          [162.13, 56.122],
          [161.701, 55.286],
          [162.117, 54.855],
          [160.369, 54.344],
          [160.022, 53.203],
          [158.531, 52.959],
          [158.231, 51.943],
          [156.79, 51.011],
          [156.42, 51.7],
          [155.992, 53.159],
          [155.434, 55.381],
          [155.914, 56.768],
          [156.758, 57.365],
          [156.81, 57.832],
          [158.364, 58.056],
          [160.151, 59.315],
          [161.872, 60.343],
          [163.67, 61.141],
          [164.474, 62.551],
          [163.258, 62.466],
          [162.658, 61.643],
          [160.122, 60.544],
          [159.302, 61.774],
          [156.721, 61.435],
          [154.218, 59.758],
          [155.044, 59.145],
          [152.812, 58.884],
          [151.266, 58.781],
          [151.338, 59.504],
          [149.784, 59.656],
          [148.545, 59.164],
          [145.487, 59.336],
          [142.198, 59.04],
          [138.958, 57.088],
          [135.126, 54.73],
          [136.702, 54.604],
          [137.193, 53.977],
          [138.165, 53.755],
          [138.805, 54.255],
          [139.901, 54.19],
          [141.345, 53.09],
          [141.379, 52.239],
          [140.597, 51.24],
          [140.513, 50.045],
          [140.062, 48.447],
          [138.555, 47],
          [138.22, 46.308],
          [136.862, 45.143],
          [135.515, 43.989],
          [134.87, 43.398],
          [133.537, 42.812],
          [132.906, 42.799],
          [132.278, 43.284],
          [130.936, 42.553],
          [130.78, 42.22],
          [130.4, 42.28],
          [129.966, 41.941],
          [129.667, 41.601],
          [129.705, 40.883],
          [129.188, 40.662],
          [129.01, 40.485],
          [128.633, 40.19],
          [127.968, 40.026],
          [127.534, 39.757],
          [127.502, 39.324],
          [127.385, 39.214],
          [127.783, 39.051],
          [128.35, 38.612],
          [129.213, 37.432],
          [129.461, 36.784],
          [129.468, 35.632],
          [129.091, 35.083],
          [128.186, 34.891],
          [127.386, 34.476],
          [126.486, 34.39],
          [126.374, 34.935],
          [126.559, 35.685],
          [126.117, 36.726],
          [126.86, 36.894],
          [126.175, 37.75],
          [125.689, 37.94],
          [125.568, 37.752],
          [125.275, 37.669],
          [125.24, 37.857],
          [124.981, 37.949],
          [124.712, 38.108],
          [124.986, 38.549],
          [125.222, 38.666],
          [125.133, 38.849],
          [125.387, 39.388],
          [125.321, 39.552],
          [124.737, 39.66],
          [124.266, 39.929],
          [122.868, 39.638],
          [122.132, 39.17],
          [121.055, 38.898],
          [121.586, 39.361],
          [121.377, 39.75],
          [122.169, 40.422],
          [121.641, 40.946],
          [120.769, 40.594],
          [119.64, 39.898],
          [119.023, 39.252],
          [118.043, 39.204],
          [117.533, 38.738],
          [118.06, 38.062],
          [118.878, 37.897],
          [118.912, 37.448],
          [119.703, 37.156],
          [120.823, 37.87],
          [121.711, 37.481],
          [122.358, 37.455],
          [122.52, 36.931],
          [121.104, 36.651],
          [120.637, 36.112],
          [119.665, 35.61],
          [119.151, 34.91],
          [120.227, 34.36],
          [120.62, 33.377],
          [121.229, 32.46],
          [121.908, 31.692],
          [121.892, 30.949],
          [121.264, 30.676],
          [121.503, 30.143],
          [122.092, 29.833],
          [121.938, 29.018],
          [121.685, 28.226],
          [121.126, 28.136],
          [120.396, 27.053],
          [119.586, 25.741],
          [118.657, 24.547],
          [117.282, 23.625],
          [115.891, 22.783],
          [114.764, 22.668],
          [114.153, 22.224],
          [113.807, 22.548],
          [113.241, 22.052],
          [111.844, 21.55],
          [110.786, 21.397],
          [110.444, 20.341],
          [109.89, 20.282],
          [109.628, 21.008],
          [109.865, 21.395],
          [108.523, 21.715],
          [108.05, 21.552],
          [106.715, 20.697],
          [105.882, 19.752],
          [105.662, 19.058],
          [106.427, 18.004],
          [107.362, 16.698],
          [108.269, 16.08],
          [108.877, 15.277],
          [109.335, 13.426],
          [109.2, 11.667],
          [108.366, 11.008],
          [107.221, 10.365],
          [106.405, 9.531],
          [105.158, 8.6],
          [104.795, 9.241],
          [105.076, 9.919],
          [104.334, 10.487],
          [103.497, 10.633],
          [103.091, 11.154],
          [102.585, 12.187],
          [101.687, 12.646],
          [100.832, 12.627],
          [100.979, 13.413],
          [100.098, 13.407],
          [100.019, 12.307],
          [99.479, 10.846],
          [99.154, 9.963],
          [99.222, 9.239],
          [99.874, 9.208],
          [100.28, 8.295],
          [100.459, 7.43],
          [101.017, 6.857],
          [101.623, 6.741],
          [102.141, 6.222],
          [102.371, 6.128],
          [102.962, 5.524],
          [103.381, 4.855],
          [103.439, 4.182],
          [103.332, 3.727],
          [103.43, 3.383],
          [103.503, 2.791],
          [103.855, 2.516],
          [104.248, 1.631],
          [104.229, 1.293],
          [103.52, 1.226],
          [102.574, 1.967],
          [101.391, 2.761],
          [101.274, 3.27],
          [100.695, 3.939],
          [100.557, 4.767],
          [100.197, 5.313],
          [100.306, 6.041],
          [100.086, 6.464],
          [99.691, 6.848],
          [99.52, 7.344],
          [98.988, 7.908],
          [98.504, 8.382],
          [98.34, 7.794],
          [98.15, 8.35],
          [98.259, 8.974],
          [98.554, 9.933],
          [98.457, 10.675],
          [98.765, 11.441],
          [98.428, 12.033],
          [98.51, 13.122],
          [98.104, 13.641],
          [97.778, 14.837],
          [97.597, 16.101],
          [97.165, 16.929],
          [96.506, 16.427],
          [95.369, 15.714],
          [94.808, 15.804],
          [94.189, 16.038],
          [94.534, 17.277],
          [94.325, 18.214],
          [93.541, 19.367],
          [93.663, 19.727],
          [93.078, 19.855],
          [92.369, 20.671],
          [92.083, 21.192],
          [92.025, 21.702],
          [91.835, 22.183],
          [91.417, 22.765],
          [90.496, 22.805],
          [90.587, 22.393],
          [90.273, 21.836],
          [89.847, 22.039],
          [89.702, 21.857],
          [89.419, 21.966],
          [89.032, 22.056],
          [88.889, 21.691],
          [88.208, 21.703],
          [86.976, 21.495],
          [87.033, 20.743],
          [86.499, 20.152],
          [85.06, 19.479],
          [83.941, 18.302],
          [83.189, 17.671],
          [82.193, 17.017],
          [82.191, 16.557],
          [81.693, 16.31],
          [80.792, 15.952],
          [80.325, 15.899],
          [80.025, 15.136],
          [80.233, 13.836],
          [80.286, 13.006],
          [79.862, 12.056],
          [79.858, 10.357],
          [79.341, 10.309],
          [78.885, 9.546],
          [79.19, 9.217],
          [78.278, 8.933],
          [77.941, 8.253],
          [77.54, 7.966],
          [76.593, 8.899],
          [76.13, 10.3],
          [75.747, 11.308],
          [75.396, 11.781],
          [74.865, 12.742],
          [74.617, 13.993],
          [74.444, 14.617],
          [73.534, 15.991],
          [73.12, 17.929],
          [72.821, 19.208],
          [72.825, 20.419],
          [72.631, 21.356],
          [71.175, 20.758],
          [70.471, 20.877],
          [69.164, 22.089],
          [69.645, 22.451],
          [69.35, 22.843],
          [68.177, 23.692],
          [67.444, 23.945],
          [67.146, 24.664],
          [66.373, 25.425],
          [64.531, 25.237],
          [62.906, 25.219],
          [61.497, 25.078],
          [59.616, 25.38],
          [58.526, 25.61],
          [57.397, 25.74],
          [56.971, 26.966],
          [56.492, 27.143],
          [55.724, 26.965],
          [54.715, 26.481],
          [53.493, 26.813],
          [52.484, 27.581],
          [51.521, 27.866],
          [50.853, 28.815],
          [50.115, 30.148],
          [49.577, 29.986],
          [48.941, 30.317],
          [48.568, 29.927],
          [47.974, 29.976],
          [48.183, 29.534],
          [48.094, 29.306],
          [48.416, 28.552],
          [48.808, 27.69],
          [49.3, 27.461],
          [49.471, 27.11],
          [50.153, 26.69],
          [50.213, 26.277],
          [50.113, 25.944],
          [50.24, 25.608],
          [50.528, 25.328],
          [50.661, 25],
          [50.81, 24.755],
          [50.744, 25.482],
          [51.013, 26.007],
          [51.286, 26.115],
          [51.589, 25.801],
          [51.607, 25.216],
          [51.39, 24.628],
          [51.58, 24.245],
          [51.758, 24.294],
          [51.794, 24.02],
          [52.577, 24.177],
          [53.404, 24.151],
          [54.008, 24.122],
          [54.693, 24.798],
          [55.439, 25.439],
          [56.071, 26.055],
          [56.362, 26.396],
          [56.486, 26.309],
          [56.391, 25.896],
          [56.261, 25.715],
          [56.397, 24.925],
          [56.845, 24.242],
          [57.404, 23.879],
          [58.137, 23.748],
          [58.729, 23.566],
          [59.18, 22.992],
          [59.45, 22.66],
          [59.808, 22.534],
          [59.806, 22.31],
          [59.442, 21.714],
          [59.282, 21.434],
          [58.861, 21.114],
          [58.488, 20.429],
          [58.034, 20.482],
          [57.826, 20.243],
          [57.666, 19.736],
          [57.789, 19.068],
          [57.695, 18.945],
          [57.234, 18.948],
          [56.61, 18.574],
          [56.512, 18.087],
          [56.284, 17.876],
          [55.661, 17.884],
          [55.27, 17.632],
          [55.275, 17.228],
          [54.791, 16.951],
          [54.239, 17.045],
          [53.57, 16.708],
          [53.109, 16.651],
          [52.385, 16.383],
          [52.192, 15.938],
          [52.168, 15.597],
          [51.172, 15.175],
          [49.575, 14.709],
          [48.679, 14.003],
          [48.239, 13.948],
          [47.939, 14.007],
          [47.354, 13.592],
          [46.717, 13.4],
          [45.878, 13.348],
          [45.625, 13.291],
          [45.406, 13.027],
          [45.144, 12.954],
          [44.99, 12.7],
          [44.495, 12.722],
          [44.175, 12.586],
          [43.483, 12.637],
          [43.223, 13.221],
          [43.252, 13.768],
          [43.088, 14.063],
          [42.892, 14.802],
          [42.605, 15.213],
          [42.805, 15.262],
          [42.703, 15.719],
          [42.824, 15.912],
          [42.779, 16.348],
          [42.65, 16.775],
          [42.348, 17.076],
          [42.271, 17.475],
          [41.755, 17.833],
          [41.221, 18.672],
          [40.939, 19.487],
          [40.248, 20.175],
          [39.802, 20.339],
          [39.14, 21.292],
          [39.024, 21.987],
          [39.066, 22.58],
          [38.493, 23.688],
          [38.024, 24.079],
          [37.484, 24.286],
          [37.155, 24.859],
          [37.209, 25.084],
          [36.932, 25.603],
          [36.64, 25.826],
          [36.249, 26.57],
          [35.64, 27.377],
          [35.13, 28.063],
          [34.632, 28.058],
          [34.788, 28.607],
          [34.832, 28.958],
          [34.956, 29.357],
          [34.923, 29.501],
          [34.642, 29.099],
          [34.427, 28.344],
          [34.154, 27.823],
          [33.922, 27.649],
          [33.588, 27.971],
          [33.137, 28.418],
          [32.423, 29.851],
          [32.32, 29.76],
          [32.735, 28.705],
          [33.349, 27.7],
          [34.105, 26.142],
          [34.474, 25.599],
          [34.795, 25.034],
          [35.693, 23.927],
          [35.494, 23.753],
          [35.526, 23.102],
          [36.691, 22.205],
          [36.866, 22],
          [37.189, 21.019],
          [36.969, 20.838],
          [37.115, 19.808],
          [37.482, 18.614],
          [37.863, 18.368],
          [38.41, 17.998],
          [38.991, 16.841],
          [39.266, 15.923],
          [39.814, 15.436],
          [41.179, 14.491],
          [41.735, 13.921],
          [42.277, 13.344],
          [42.59, 13],
          [43.081, 12.7],
          [43.318, 12.39],
          [43.286, 11.975],
          [42.716, 11.736],
          [43.145, 11.462],
          [43.471, 11.278],
          [43.667, 10.864],
          [44.118, 10.446],
          [44.614, 10.442],
          [45.557, 10.698],
          [46.646, 10.817],
          [47.526, 11.127],
          [48.022, 11.193],
          [48.379, 11.375],
          [48.948, 11.411],
          [49.268, 11.43],
          [49.729, 11.579],
          [50.259, 11.68],
          [50.732, 12.022],
          [51.111, 12.025],
          [51.134, 11.748],
          [51.042, 11.167],
          [51.045, 10.641],
          [50.834, 10.28],
          [50.552, 9.199],
          [50.071, 8.082],
          [49.453, 6.805],
          [48.594, 5.339],
          [47.741, 4.219],
          [46.565, 2.855],
          [45.564, 2.046],
          [44.068, 1.053],
          [43.136, 0.292],
          [42.042, -0.919],
          [41.811, -1.446],
          [41.585, -1.683],
          [40.885, -2.083],
          [40.638, -2.5],
          [40.263, -2.573],
          [40.121, -3.278],
          [39.8, -3.681],
          [39.605, -4.346],
          [39.202, -4.677],
          [38.74, -5.909],
          [38.8, -6.476],
          [39.44, -6.84],
          [39.47, -7.1],
          [39.195, -7.704],
          [39.252, -8.008],
          [39.187, -8.485],
          [39.536, -9.112],
          [39.95, -10.098],
          [40.317, -10.317],
          [40.479, -10.765],
          [40.437, -11.762],
          [40.561, -12.639],
          [40.6, -14.202],
          [40.776, -14.692],
          [40.477, -15.406],
          [40.089, -16.101],
          [39.453, -16.721],
          [38.538, -17.101],
          [37.411, -17.586],
          [36.281, -18.66],
          [35.896, -18.842],
          [35.198, -19.553],
          [34.786, -19.784],
          [34.702, -20.497],
          [35.176, -21.254],
          [35.373, -21.841],
          [35.386, -22.14],
          [35.563, -22.09],
          [35.534, -23.071],
          [35.372, -23.535],
          [35.607, -23.706],
          [35.459, -24.123],
          [35.041, -24.478],
          [34.216, -24.816],
          [33.013, -25.357],
          [32.575, -25.727],
          [32.66, -26.148],
          [32.916, -26.216],
          [32.83, -26.742],
          [32.58, -27.47],
          [32.462, -28.301],
          [32.203, -28.752],
          [31.521, -29.257],
          [31.326, -29.402],
          [30.902, -29.91],
          [30.623, -30.424],
          [30.056, -31.14],
          [28.925, -32.172],
          [28.22, -32.772],
          [27.465, -33.227],
          [26.419, -33.615],
          [25.91, -33.667],
          [25.781, -33.945],
          [25.173, -33.797],
          [24.678, -33.987],
          [23.594, -33.794],
          [22.988, -33.916],
          [22.574, -33.864],
          [21.543, -34.259],
          [20.689, -34.417],
          [20.071, -34.795],
          [19.617, -34.819],
          [19.193, -34.463],
          [18.855, -34.444],
          [18.425, -33.998],
          [18.378, -34.136],
          [18.245, -33.868],
          [18.25, -33.281],
          [17.925, -32.611],
          [18.248, -32.429],
          [18.222, -31.662],
          [17.567, -30.726],
          [17.065, -29.879],
          [17.063, -29.876],
          [16.345, -28.577],
          [15.602, -27.821],
          [15.211, -27.091],
          [14.99, -26.117],
          [14.743, -25.393],
          [14.408, -23.853],
          [14.386, -22.657],
          [14.258, -22.111],
          [13.869, -21.699],
          [13.352, -20.873],
          [12.827, -19.673],
          [12.609, -19.045],
          [11.795, -18.069],
          [11.734, -17.302],
          [11.64, -16.673],
          [11.779, -15.794],
          [12.124, -14.878],
          [12.176, -14.449],
          [12.5, -13.548],
          [12.739, -13.138],
          [13.313, -12.484],
          [13.634, -12.039],
          [13.739, -11.298],
          [13.687, -10.731],
          [13.387, -10.374],
          [13.121, -9.767],
          [12.875, -9.167],
          [12.929, -8.959],
          [13.237, -8.563],
          [12.933, -7.596],
          [12.728, -6.927],
          [12.227, -6.294],
          [12.323, -6.1],
          [12.182, -5.79],
          [11.915, -5.038],
          [11.094, -3.979],
          [10.066, -2.969],
          [9.405, -2.144],
          [8.798, -1.111],
          [8.83, -0.779],
          [9.049, -0.459],
          [9.291, 0.269],
          [9.493, 1.01],
          [9.306, 1.161],
          [9.649, 2.284],
          [9.795, 3.073],
          [9.404, 3.734],
          [8.948, 3.904],
          [8.745, 4.352],
          [8.489, 4.496],
          [8.5, 4.772],
          [7.462, 4.412],
          [7.083, 4.465],
          [6.698, 4.241],
          [5.898, 4.263],
          [5.363, 4.888],
          [5.034, 5.612],
          [4.326, 6.271],
          [3.574, 6.258],
          [2.692, 6.259],
          [1.865, 6.142],
          [1.06, 5.929],
          [-0.508, 5.344],
          [-1.064, 5],
          [-1.965, 4.711],
          [-2.856, 4.995],
          [-3.311, 4.984],
          [-4.009, 5.18],
          [-4.65, 5.168],
          [-5.834, 4.994],
          [-6.529, 4.705],
          [-7.519, 4.338],
          [-7.712, 4.365],
          [-7.974, 4.356],
          [-9.005, 4.833],
          [-9.913, 5.594],
          [-10.765, 6.141],
          [-11.439, 6.786],
          [-11.708, 6.86],
          [-12.428, 7.263],
          [-12.949, 7.799],
          [-13.124, 8.164],
          [-13.247, 8.903],
          [-13.685, 9.495],
          [-14.074, 9.886],
          [-14.33, 10.016],
          [-14.58, 10.214],
          [-14.693, 10.656],
          [-14.839, 10.877],
          [-15.13, 11.041],
          [-15.664, 11.458],
          [-16.085, 11.525],
          [-16.315, 11.807],
          [-16.309, 11.959],
          [-16.614, 12.171],
          [-16.677, 12.385],
          [-16.841, 13.151],
          [-16.714, 13.595],
          [-17.126, 14.373],
          [-17.625, 14.73],
          [-17.185, 14.919],
          [-16.701, 15.622],
          [-16.463, 16.135],
          [-16.55, 16.674],
          [-16.271, 17.167],
          [-16.146, 18.109],
          [-16.257, 19.097],
          [-16.378, 19.594],
          [-16.278, 20.093],
          [-16.536, 20.568],
          [-17.063, 21],
          [-17.02, 21.422],
          [-16.973, 21.886],
          [-16.589, 22.158],
          [-16.262, 22.679],
          [-16.326, 23.018],
          [-15.983, 23.724],
          [-15.426, 24.359],
          [-15.089, 24.52],
          [-14.825, 25.104],
          [-14.801, 25.636],
          [-14.44, 26.255],
          [-13.774, 26.619],
          [-13.14, 27.64],
          [-12.619, 28.038],
          [-11.689, 28.149],
          [-10.901, 28.832],
          [-10.4, 29.099],
          [-9.565, 29.934],
          [-9.815, 31.178],
          [-9.435, 32.038],
          [-9.301, 32.565],
          [-8.657, 33.24],
          [-7.654, 33.697],
          [-6.912, 34.11],
          [-6.244, 35.146],
          [-5.93, 35.76],
          [-5.194, 35.755],
          [-4.591, 35.331],
          [-3.64, 35.4],
          [-2.604, 35.179],
          [-2.17, 35.169],
          [-1.209, 35.715],
          [-0.127, 35.889],
          [0.504, 36.301],
          [1.467, 36.606],
          [3.162, 36.784],
          [4.816, 36.865],
          [5.32, 36.716],
          [6.262, 37.111],
          [7.331, 37.119],
          [7.737, 36.886],
          [8.421, 36.946],
          [9.51, 37.35],
          [10.21, 37.23],
          [10.181, 36.724],
          [11.029, 37.092],
          [11.1, 36.9],
          [10.6, 36.41],
          [10.593, 35.948],
          [10.94, 35.699],
          [10.808, 34.833],
          [10.15, 34.331],
          [10.34, 33.786],
          [10.857, 33.769],
          [11.109, 33.293],
          [11.489, 33.137],
          [12.663, 32.793],
          [13.083, 32.879],
          [13.919, 32.712],
          [15.246, 32.265],
          [15.714, 31.376],
          [16.612, 31.182],
          [18.021, 30.763],
          [19.086, 30.266],
          [19.574, 30.526],
          [20.053, 30.986],
          [19.82, 31.752],
          [20.134, 32.238],
          [20.854, 32.707],
          [21.543, 32.843],
          [22.896, 32.638],
          [23.237, 32.192],
          [23.609, 32.187],
          [23.927, 32.017],
          [24.921, 31.899],
          [25.165, 31.569],
          [26.495, 31.586],
          [27.458, 31.321],
          [28.451, 31.026],
          [28.914, 30.87],
          [29.683, 31.187],
          [30.095, 31.474],
          [30.977, 31.556],
          [31.688, 31.43],
          [31.961, 30.934],
          [32.193, 31.26],
          [32.994, 31.024],
          [33.773, 30.968],
          [34.266, 31.219],
          [34.557, 31.549],
          [34.488, 31.606],
          [34.753, 32.073],
          [34.956, 32.828],
          [35.099, 33.081],
          [35.126, 33.091],
          [35.482, 33.906],
          [35.98, 34.61],
          [35.998, 34.645],
          [35.905, 35.41],
          [36.15, 35.821],
          [35.782, 36.275],
          [36.161, 36.651],
          [35.551, 36.565],
          [34.714, 36.795],
          [34.027, 36.22],
          [32.509, 36.107],
          [31.7, 36.644],
          [30.622, 36.678],
          [30.391, 36.263],
          [29.7, 36.144],
          [28.733, 36.677],
          [27.641, 36.659],
          [27.049, 37.654],
          [26.318, 38.208],
          [26.805, 38.986],
          [26.171, 39.464],
          [27.28, 40.42],
          [28.82, 40.46],
          [29.24, 41.22],
          [31.146, 41.088],
          [32.348, 41.736],
          [33.513, 42.019],
          [35.168, 42.04],
          [36.913, 41.336],
          [38.348, 40.949],
          [39.513, 41.103],
          [40.373, 41.014],
          [41.554, 41.536],
          [41.703, 41.963],
          [41.453, 42.645],
          [40.875, 43.014],
          [40.321, 43.129],
          [39.955, 43.435],
          [38.68, 44.28],
          [37.539, 44.657],
          [36.675, 45.245],
          [37.403, 45.404],
          [38.233, 46.241],
          [37.674, 46.637],
          [39.148, 47.045],
          [39.121, 47.263],
          [38.224, 47.102],
          [37.425, 47.022],
          [36.76, 46.699],
          [35.824, 46.646],
          [34.962, 46.273],
          [35.021, 45.651],
          [35.51, 45.41],
          [36.53, 45.47],
          [36.335, 45.113],
          [35.24, 44.94],
          [33.883, 44.362],
          [33.326, 44.565],
          [33.547, 45.035],
          [32.454, 45.328],
          [32.631, 45.519],
          [33.588, 45.852],
          [33.299, 46.081],
          [31.744, 46.333],
          [31.675, 46.706],
          [30.749, 46.583],
          [30.378, 46.032],
          [29.603, 45.293],
          [29.627, 45.036],
          [29.142, 44.82],
          [28.838, 44.914],
          [28.558, 43.708],
          [28.039, 43.293],
          [27.674, 42.578],
          [27.997, 42.008],
          [28.115, 41.623],
          [28.989, 41.3],
          [28.807, 41.055],
          [27.619, 41],
          [27.193, 40.691],
          [26.358, 40.152],
          [26.043, 40.618],
          [26.057, 40.824],
          [25.448, 40.852],
          [24.926, 40.947],
          [23.715, 40.687],
          [24.408, 40.125],
          [23.9, 39.962],
          [23.343, 39.961],
          [22.814, 40.476],
          [22.626, 40.257],
          [22.85, 39.659],
          [23.35, 39.19],
          [22.973, 38.971],
          [23.53, 38.51],
          [24.025, 38.22],
          [24.04, 37.655],
          [23.115, 37.92],
          [23.41, 37.41],
          [22.775, 37.305],
          [23.154, 36.422],
          [22.49, 36.41],
          [21.67, 36.845],
          [21.295, 37.645],
          [21.12, 38.31],
          [20.73, 38.77],
          [20.218, 39.34],
          [20.15, 39.625],
          [19.98, 39.695],
          [19.96, 39.915],
          [19.406, 40.251],
          [19.319, 40.727],
          [19.404, 41.409],
          [19.54, 41.72],
          [19.372, 41.878],
          [19.162, 41.955],
          [18.882, 42.281],
          [18.45, 42.48],
          [17.51, 42.85],
          [16.93, 43.21],
          [16.016, 43.507],
          [15.174, 44.243],
          [15.376, 44.318],
          [14.92, 44.739],
          [14.902, 45.076],
          [14.259, 45.234],
          [13.952, 44.802],
          [13.657, 45.137],
          [13.68, 45.484],
          [13.715, 45.5],
          [13.938, 45.591],
          [13.142, 45.737],
          [12.329, 45.382],
          [12.384, 44.885],
          [12.261, 44.601],
          [12.589, 44.091],
          [13.527, 43.588],
          [14.03, 42.761],
          [15.143, 41.955],
          [15.926, 41.961],
          [16.17, 41.74],
          [15.889, 41.541],
          [16.785, 41.18],
          [17.519, 40.877],
          [18.377, 40.356],
          [18.48, 40.169],
          [18.294, 39.811],
          [17.739, 40.278],
          [16.87, 40.442],
          [16.449, 39.795],
          [17.172, 39.425],
          [17.053, 38.903],
          [16.635, 38.844],
          [16.101, 37.986],
          [15.684, 37.909],
          [15.688, 38.215],
          [15.892, 38.751],
          [16.109, 38.964],
          [15.719, 39.544],
          [15.414, 40.048],
          [14.998, 40.173],
          [14.703, 40.605],
          [14.061, 40.786],
          [13.628, 41.188],
          [12.888, 41.253],
          [12.107, 41.705],
          [11.192, 42.356],
          [10.512, 42.932],
          [10.2, 43.92],
          [9.703, 44.036],
          [8.889, 44.366],
          [8.429, 44.231],
          [7.851, 43.767],
          [7.435, 43.694],
          [6.529, 43.129],
          [4.557, 43.4],
          [3.101, 43.075],
          [2.986, 42.473],
          [3.039, 41.892],
          [2.092, 41.226],
          [0.81, 41.015],
          [0.721, 40.678],
          [0.107, 40.124],
          [-0.279, 39.31],
          [0.111, 38.739],
          [-0.467, 38.292],
          [-0.683, 37.642],
          [-1.438, 37.443],
          [-2.146, 36.674],
          [-3.416, 36.659],
          [-4.369, 36.678],
          [-4.995, 36.325],
          [-5.377, 35.947],
          [-5.866, 36.03],
          [-6.237, 36.368],
          [-6.52, 36.943],
          [-7.454, 37.098],
          [-7.856, 36.838],
          [-8.383, 36.979],
          [-8.899, 36.869],
          [-8.746, 37.651],
          [-8.84, 38.266],
          [-9.287, 38.359],
          [-9.526, 38.737],
          [-9.447, 39.392],
          [-9.048, 39.755],
          [-8.977, 40.159],
          [-8.769, 40.761],
          [-8.791, 41.184],
          [-8.991, 41.544],
          [-9.035, 41.881],
          [-8.984, 42.593],
          [-9.393, 43.027],
          [-7.978, 43.748],
          [-6.755, 43.568],
          [-5.412, 43.574],
          [-4.348, 43.404],
          [-3.518, 43.456],
          [-1.901, 43.423],
          [-1.384, 44.023],
          [-1.194, 46.015],
          [-2.226, 47.065],
          [-2.963, 47.57],
          [-4.492, 47.955],
          [-4.592, 48.684],
          [-3.296, 48.902],
          [-1.617, 48.644],
          [-1.933, 49.776],
          [-0.989, 49.347],
          [1.339, 50.127],
          [1.639, 50.947],
          [2.513, 51.148],
          [3.315, 51.346],
          [3.83, 51.62],
          [4.706, 53.092],
          [6.074, 53.51],
          [6.905, 53.482],
          [7.101, 53.694],
          [7.936, 53.748],
          [8.122, 53.528],
          [8.801, 54.021],
          [8.572, 54.396],
          [8.526, 54.963],
          [8.12, 55.518],
          [8.09, 56.54],
          [8.257, 56.81],
          [8.544, 57.11],
          [9.424, 57.172],
          [9.776, 57.448],
          [10.58, 57.73],
          [10.546, 57.216],
          [10.25, 56.89],
          [10.37, 56.61],
          [10.912, 56.459],
          [10.668, 56.081],
          [10.37, 56.19],
          [9.65, 55.47],
          [9.922, 54.983],
          [9.94, 54.597],
          [10.95, 54.364],
          [10.94, 54.009],
          [11.956, 54.196],
          [12.518, 54.471],
          [13.648, 54.076],
          [14.12, 53.757],
          [14.803, 54.051],
          [16.364, 54.513],
          [17.623, 54.852],
          [18.621, 54.683],
          [18.696, 54.439],
          [19.661, 54.426],
          [19.888, 54.866],
          [21.268, 55.19],
          [21.056, 56.031],
          [21.091, 56.784],
          [21.582, 57.412],
          [22.524, 57.753],
          [23.318, 57.006],
          [24.121, 57.026],
          [24.313, 57.794],
          [24.429, 58.383],
          [24.061, 58.258],
          [23.427, 58.613],
          [23.34, 59.187],
          [24.604, 59.466],
          [25.864, 59.611],
          [26.949, 59.446],
          [27.981, 59.476],
          [29.118, 60.028],
          [28.07, 60.503],
          [26.255, 60.424],
          [24.497, 60.057],
          [22.87, 59.846],
          [22.291, 60.392],
          [21.322, 60.72],
          [21.545, 61.705],
          [21.059, 62.607],
          [21.536, 63.19],
          [22.443, 63.818],
          [24.731, 64.902],
          [25.398, 65.112],
          [25.294, 65.534],
          [23.904, 66.007],
          [22.183, 65.724],
          [21.214, 65.026],
          [21.37, 64.414],
          [19.779, 63.61],
          [17.848, 62.75],
          [17.12, 61.341],
          [17.831, 60.637],
          [18.788, 60.082],
          [17.869, 58.954],
          [16.829, 58.72],
          [16.448, 57.041],
          [15.88, 56.104],
          [14.667, 56.201],
          [14.101, 55.408],
          [12.943, 55.362],
          [12.625, 56.307],
          [11.788, 57.442],
          [11.027, 58.856],
          [10.357, 59.47],
          [8.382, 58.313],
          [7.049, 58.079],
          [5.666, 58.588],
          [5.308, 59.663],
          [4.992, 61.971],
          [5.913, 62.615],
          [8.554, 63.454],
          [10.528, 64.486],
          [12.358, 65.88],
          [14.761, 67.811],
          [16.436, 68.563],
          [19.184, 69.818],
          [21.378, 70.255],
          [23.024, 70.202],
          [24.547, 71.031],
          [26.37, 70.986],
          [28.166, 71.185],
          [31.294, 70.454],
          [30.005, 70.186],
          [31.101, 69.558],
          [32.133, 69.906],
          [33.776, 69.302],
          [36.514, 69.063],
          [40.292, 67.932],
          [41.06, 67.457],
          [41.126, 66.792],
          [40.016, 66.266],
          [38.383, 66],
          [33.919, 66.76],
          [33.185, 66.633],
          [34.815, 65.9],
          [34.944, 64.414],
          [36.231, 64.109],
          [37.013, 63.85],
          [37.142, 64.335],
          [36.518, 64.78],
          [37.176, 65.143],
          [39.594, 64.521],
          [40.436, 64.765],
          [39.763, 65.497],
          [42.093, 66.476],
          [43.016, 66.419],
          [43.95, 66.069],
          [44.532, 66.756],
          [43.698, 67.352],
          [44.188, 67.951],
          [43.453, 68.571],
          [46.25, 68.25],
          [46.821, 67.69],
          [45.555, 67.567],
          [45.562, 67.01],
          [46.349, 66.668],
          [47.894, 66.885],
          [48.139, 67.523],
          [50.228, 67.999],
          [53.718, 68.857],
          [54.472, 68.808],
          [53.486, 68.201],
          [54.726, 68.097],
          [55.443, 68.439],
          [57.317, 68.466],
          [58.802, 68.881],
          [59.942, 68.279],
          [61.078, 68.941],
          [60.03, 69.52],
          [60.55, 69.85],
          [63.504, 69.547],
          [64.888, 69.235],
          [68.512, 68.092],
          [69.181, 68.616],
          [68.164, 69.144],
          [68.135, 69.357],
          [66.93, 69.455],
          [67.26, 69.929],
          [66.725, 70.709],
          [66.695, 71.029],
          [68.54, 71.935],
          [69.196, 72.844],
          [69.94, 73.04],
          [72.588, 72.776],
          [72.796, 72.22],
          [71.848, 71.409],
          [72.47, 71.09],
          [72.792, 70.391],
          [72.565, 69.021],
          [73.668, 68.408],
          [73.239, 67.74],
          [71.28, 66.32],
          [72.423, 66.173],
          [72.821, 66.533],
          [73.921, 66.789],
          [74.187, 67.284],
          [75.052, 67.76],
          [74.469, 68.329],
          [74.936, 68.989],
          [73.842, 69.071],
          [73.602, 69.628],
          [74.4, 70.632],
          [73.101, 71.447],
          [74.891, 72.121],
          [74.659, 72.832],
          [75.158, 72.855],
          [75.683, 72.3],
          [75.289, 71.336],
          [76.359, 71.153],
          [75.903, 71.874],
          [77.577, 72.267],
          [79.652, 72.32],
          [81.5, 71.75],
          [80.611, 72.583],
          [80.511, 73.648],
          [82.25, 73.85],
          [84.655, 73.806],
          [86.822, 73.937],
          [86.01, 74.46],
          [87.167, 75.117],
          [88.316, 75.144],
          [90.26, 75.64],
          [92.901, 75.773],
          [93.234, 76.047],
          [95.86, 76.14],
          [96.678, 75.916],
          [98.922, 76.447],
          [100.76, 76.43],
          [101.035, 76.862],
          [101.991, 77.287],
          [104.352, 77.698],
          [106.067, 77.374],
          [104.705, 77.128],
          [106.97, 76.974],
        ],
        [
          [49.11, 41.282],
          [49.619, 40.573],
          [50.085, 40.526],
          [50.393, 40.257],
          [49.569, 40.176],
          [49.395, 39.399],
          [49.223, 39.049],
          [48.857, 38.815],
          [48.883, 38.32],
          [49.2, 37.583],
          [50.148, 37.375],
          [50.842, 36.873],
          [52.264, 36.701],
          [53.826, 36.965],
          [53.922, 37.199],
          [53.735, 37.906],
          [53.881, 38.952],
          [53.101, 39.291],
          [53.358, 39.975],
          [52.694, 40.034],
          [52.915, 40.877],
          [53.858, 40.631],
          [54.737, 40.951],
          [54.008, 41.551],
          [53.722, 42.123],
          [52.917, 41.868],
          [52.815, 41.135],
          [52.503, 41.783],
          [52.446, 42.027],
          [52.692, 42.444],
          [52.502, 42.792],
          [51.343, 43.133],
          [50.891, 44.031],
          [50.339, 44.284],
          [50.306, 44.61],
          [51.279, 44.515],
          [51.317, 45.246],
          [52.167, 45.409],
          [53.041, 45.259],
          [53.221, 46.235],
          [53.043, 46.853],
          [52.042, 46.805],
          [51.192, 47.049],
          [50.034, 46.609],
          [49.101, 46.399],
          [48.646, 45.806],
          [47.676, 45.641],
          [46.682, 44.609],
          [47.591, 43.66],
          [47.492, 42.987],
          [48.584, 41.809],
          [49.11, 41.282],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-72.58, 19.872],
          [-71.712, 19.714],
          [-71.587, 19.885],
          [-70.807, 19.88],
          [-70.214, 19.623],
          [-69.951, 19.648],
          [-69.769, 19.293],
          [-69.222, 19.313],
          [-69.254, 19.015],
          [-68.809, 18.979],
          [-68.318, 18.612],
          [-68.689, 18.205],
          [-69.165, 18.423],
          [-69.624, 18.381],
          [-69.953, 18.428],
          [-70.133, 18.246],
          [-70.517, 18.184],
          [-70.669, 18.427],
          [-71, 18.283],
          [-71.4, 17.599],
          [-71.658, 17.758],
          [-71.708, 18.045],
          [-72.372, 18.215],
          [-72.844, 18.146],
          [-73.455, 18.218],
          [-73.922, 18.031],
          [-74.458, 18.343],
          [-74.37, 18.665],
          [-73.45, 18.526],
          [-72.695, 18.446],
          [-72.335, 18.668],
          [-72.792, 19.102],
          [-72.784, 19.484],
          [-73.415, 19.64],
          [-73.19, 19.916],
          [-72.58, 19.872],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-45.155, -78.047],
          [-43.921, -78.478],
          [-43.49, -79.086],
          [-43.372, -79.517],
          [-43.333, -80.026],
          [-44.881, -80.34],
          [-46.506, -80.594],
          [-48.386, -80.829],
          [-50.482, -81.025],
          [-52.852, -80.967],
          [-54.164, -80.634],
          [-53.988, -80.222],
          [-51.853, -79.948],
          [-50.991, -79.615],
          [-50.365, -79.183],
          [-49.914, -78.811],
          [-49.307, -78.459],
          [-48.661, -78.047],
          [-48.661, -78.047],
          [-48.151, -78.047],
          [-46.663, -77.831],
          [-45.155, -78.047],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-59.572, -80.04],
          [-59.866, -80.55],
          [-60.16, -81],
          [-62.255, -80.863],
          [-64.488, -80.922],
          [-65.742, -80.589],
          [-65.742, -80.55],
          [-66.29, -80.256],
          [-64.038, -80.295],
          [-61.883, -80.393],
          [-61.139, -79.981],
          [-60.61, -79.629],
          [-59.572, -80.04],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-121.212, -73.501],
          [-119.919, -73.658],
          [-118.724, -73.481],
          [-119.292, -73.834],
          [-120.232, -74.089],
          [-121.623, -74.01],
          [-122.622, -73.658],
          [-122.622, -73.658],
          [-122.406, -73.325],
          [-121.212, -73.501],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-125.56, -73.481],
          [-124.032, -73.873],
          [-124.619, -73.834],
          [-125.912, -73.736],
          [-127.283, -73.462],
          [-127.283, -73.462],
          [-126.558, -73.246],
          [-125.56, -73.481],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-98.982, -71.933],
          [-97.885, -72.071],
          [-96.788, -71.953],
          [-96.2, -72.521],
          [-96.984, -72.443],
          [-98.198, -72.482],
          [-99.432, -72.443],
          [-100.783, -72.502],
          [-101.802, -72.306],
          [-102.331, -71.894],
          [-102.331, -71.894],
          [-101.704, -71.718],
          [-100.431, -71.855],
          [-98.982, -71.933],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-68.451, -70.956],
          [-68.334, -71.406],
          [-68.51, -71.798],
          [-68.784, -72.171],
          [-69.959, -72.308],
          [-71.076, -72.504],
          [-72.388, -72.484],
          [-71.898, -72.092],
          [-73.074, -72.229],
          [-74.19, -72.367],
          [-74.954, -72.073],
          [-75.013, -71.661],
          [-73.916, -71.269],
          [-73.916, -71.269],
          [-73.23, -71.152],
          [-72.075, -71.191],
          [-71.781, -70.681],
          [-71.722, -70.309],
          [-71.742, -69.506],
          [-71.174, -69.035],
          [-70.253, -68.879],
          [-69.724, -69.251],
          [-69.489, -69.623],
          [-69.059, -70.074],
          [-68.726, -70.505],
          [-68.451, -70.956],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-159.208, -79.497],
          [-161.128, -79.634],
          [-162.44, -79.281],
          [-163.027, -78.929],
          [-163.067, -78.87],
          [-163.713, -78.596],
          [-163.713, -78.596],
          [-163.106, -78.223],
          [-161.245, -78.38],
          [-160.246, -78.694],
          [-159.482, -79.046],
          [-159.208, -79.497],
        ],
      ],
    },
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-25.103, 17.200080358351908],
        [-25.351, 17.084599459747487],
        [-25.307, 16.90598833782888],
        [-25.175, 16.90598833782888],
        [-24.944, 17.084599459747487],
        [-25.103822722413838, 17.200080358351908],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-24.939027800538838, 16.92175497945169],
        [-25.070863738038838, 16.869194380614676],
        [-25.048891081788838, 16.779807819461045],
        [-24.900575652101338, 16.779807819461045],
        [-24.939027800538838, 16.92175497945169],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-24.461122527101338, 16.685117375863918],
        [-24.186464323976338, 16.664068673761324],
        [-23.999696745851338, 16.55879049190793],
        [-24.071107878663838, 16.506129800217906],
        [-24.252382292726338, 16.59038000375234],
        [-24.318300261476338, 16.521929515948138],
        [-24.461122527101338, 16.685117375863918],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-23.736024870851338, 15.301654253236265],
        [-23.785463347413838, 15.105520924939139],
        [-23.637147917726338, 14.909206202671347],
        [-23.505311980226338, 14.914514372521895],
        [-23.411928191163838, 15.015344664965532],
        [-23.620668425538838, 15.259262524645242],
        [-23.736024870851338, 15.301654253236265],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-22.928529753663838, 16.179314873284437],
        [-22.966981902101338, 16.020983525412927],
        [-22.824159636476338, 15.941770631846884],
        [-22.659364714601338, 16.042101660655486],
        [-22.692323698976338, 16.205691129250763],
        [-22.928529753663838, 16.179314873284437],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-22.873598113038838, 16.8481660437944],
        [-22.868104948976338, 16.600908688560114],
        [-22.955995573976338, 16.600908688560114],
        [-23.010927214601338, 16.790326072813762],
        [-22.873598113038838, 16.8481660437944],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-23.247133269288838, 15.264561959183181],
        [-23.104311003663838, 15.33873997851962],
        [-23.071352019288838, 15.142641207764859],
        [-23.159242644288838, 15.089610243931597],
        [-23.252626433351338, 15.158547909299557],
        [-23.247133269288838, 15.264561959183181],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-24.296327605226338, 15.057785308921385],
        [-24.246889128663838, 14.87204534979053],
        [-24.389711394288838, 14.797704454086814],
        [-24.527040495851338, 14.909206202671347],
        [-24.477602019288838, 15.052480690412155],
        [-24.296327605226338, 15.057785308921385],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-64.71537024080465, 18.38904276081792],
        [-64.6412125259609, 18.44767523488749],
        [-64.57117468416402, 18.46200457632027],
        [-64.51898962557027, 18.432041862564116],
        [-64.57804113924215, 18.411195154679017],
        [-64.6631851822109, 18.38383001889086],
        [-64.71537024080465, 18.38904276081792],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-64.88703161775777, 17.770610353509067],
        [-64.76618200838277, 17.788918138399378],
        [-64.70987707674215, 17.74706901794771],
        [-64.5643082290859, 17.761455757803226],
        [-64.5807877212734, 17.737913217794926],
        [-64.7620621353359, 17.6882021415937],
        [-64.89801794588277, 17.68427699652331],
        [-64.88703161775777, 17.770610353509067],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-61.211351816736794, 16.236119142213088],
        [-61.436571543299294, 16.193921952818616],
        [-61.595873301111794, 16.23084498792849],
        [-61.557421152674294, 16.056718852087588],
        [-61.683763926111794, 15.956395164101362],
        [-61.804613535486794, 16.151715736254783],
        [-61.788134043299294, 16.32575810102814],
        [-61.628832285486794, 16.294125499472226],
        [-61.502489512049294, 16.331029704275757],
        [-61.540941660486794, 16.462773493051767],
        [-61.458544199549294, 16.499645750676642],
        [-61.370653574549294, 16.336301165411204],
        [-61.211351816736794, 16.236119142213088],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-62.81048498856717, 17.416884274252073],
        [-62.60998450028592, 17.238592907433475],
        [-62.66766272294217, 17.2176060935804],
        [-62.67727576005154, 17.266134480786388],
        [-62.74868689286404, 17.287115775462333],
        [-62.83932409989529, 17.335625857882],
        [-62.86054999287876, 17.3818415510617],
        [-62.81048498856717, 17.416884274252073],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-62.611984319050634, 17.200892460314964],
        [-62.62709052022251, 17.14184895598545],
        [-62.60511786397251, 17.091975374835776],
        [-62.548812932331884, 17.099851039383207],
        [-62.53370673116001, 17.147098028500128],
        [-62.56117255147251, 17.20613986138593],
        [-62.611984319050634, 17.200892460314964],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-62.20411688741001, 16.821376554194813],
        [-62.246688908894384, 16.735912866046245],
        [-62.18763739522251, 16.67409214495815],
        [-62.15742499287876, 16.67409214495815],
        [-62.142318791706884, 16.69250892072297],
        [-62.14918524678501, 16.759583580447607],
        [-62.20411688741001, 16.821376554194813],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-61.81235130130949, 17.175309250299335],
        [-61.68326194584074, 17.09656955295212],
        [-61.68326194584074, 17.036179895406704],
        [-61.74917991459074, 16.981024471737545],
        [-61.90298850834074, 17.03880593882527],
        [-61.90024192630949, 17.120194964420342],
        [-61.81235130130949, 17.175309250299335],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-61.34251828041903, 15.612036892585731],
        [-61.21617550698153, 15.447966023203792],
        [-61.28209347573153, 15.214868440292092],
        [-61.37547726479403, 15.241369872298417],
        [-61.50182003823153, 15.532664066135117],
        [-61.45787472573153, 15.643777431264835],
        [-61.34251828041903, 15.612036892585731],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-61.11180538979403, 14.88066646333803],
        [-60.86461300698153, 14.662890602322651],
        [-60.82616085854403, 14.444897943899745],
        [-61.05687374916903, 14.42893882935278],
        [-61.13927121010653, 14.615057024692481],
        [-61.29857296791903, 14.827570548186298],
        [-61.11180538979403, 14.88066646333803],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-60.90156761134216, 14.117753058741393],
        [-60.84114280665466, 13.91522796264512],
        [-60.94551292384216, 13.70718869425191],
        [-61.10481468165466, 13.787225761743711],
        [-61.05537620509216, 14.037830299983773],
        [-60.90156761134216, 14.117753058741393],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-70.06152842097418, 12.623988720991566],
        [-70.05054209284918, 12.50067062301293],
        [-69.87476084284918, 12.382659084831879],
        [-69.82532236628668, 12.414849364605411],
        [-70.06152842097418, 12.623988720991566],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-69.16064951472424, 12.388024407491015],
        [-69.15515635066174, 12.27532952664228],
        [-69.07275888972424, 12.210910761858454],
        [-69.00684092097424, 12.141106077395113],
        [-68.78162119441174, 12.039050954214074],
        [-68.72668955378674, 12.092769030974424],
        [-68.88049814753674, 12.205541822720217],
        [-69.00134775691174, 12.221648313473528],
        [-69.16064951472424, 12.388024407491015],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-68.36963388972424, 12.318266621740234],
        [-68.12793467097424, 12.194803618007029],
        [-68.24878428034924, 12.022933434214233],
        [-68.39160654597424, 12.205541822720217],
        [-68.36963388972424, 12.318266621740234],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-31.2299286139081, 39.52237209853903],
        [-31.258767725236225, 39.47150593735423],
        [-31.24915468812685, 39.37603158945352],
        [-31.162637354142475, 39.371785249822445],
        [-31.15577089906435, 39.422724278076814],
        [-31.1365448248456, 39.45242153173999],
        [-31.151651026017475, 39.504361256730434],
        [-31.2299286139081, 39.52237209853903],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-28.70999143860729, 38.646358854474656],
        [-28.837707503060415, 38.60344355341389],
        [-28.763549788216665, 38.557280965085305],
        [-28.760803206185415, 38.5164614284673],
        [-28.620727522591665, 38.51753592353819],
        [-28.598754866341665, 38.60344355341389],
        [-28.70999143860729, 38.646358854474656],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-28.409240706185415, 38.56372403754476],
        [-28.49026487610729, 38.55942872008012],
        [-28.53970335266979, 38.52720565743713],
        [-28.524597151497915, 38.469167769558496],
        [-28.43533323548229, 38.418615258826414],
        [-28.22933958313854, 38.38202328958939],
        [-28.173034651497915, 38.41215919846897],
        [-28.063171370247915, 38.39924534712899],
        [-28.01510618470104, 38.41538730076023],
        [-28.409240706185415, 38.56372403754476],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-28.32172089362939, 38.75524283059821],
        [-28.084141547926265, 38.689886229105575],
        [-27.749058540113765, 38.545032137868084],
        [-27.828709419020015, 38.52784486049522],
        [-28.207737739332515, 38.66630033122423],
        [-28.32172089362939, 38.75524283059821],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-27.376696098566754, 38.716480166253],
        [-27.272325981379254, 38.648943097681276],
        [-27.077318657160504, 38.645725457079806],
        [-27.049852836848004, 38.736835976563526],
        [-27.13911675286363, 38.78395347869344],
        [-27.297045219660504, 38.8021496354802],
        [-27.37532280755113, 38.77110633617346],
        [-27.376696098566754, 38.716480166253],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-25.78368229093985, 37.91689581864256],
        [-25.850973550705476, 37.864874561531046],
        [-25.70128483000235, 37.728143961714245],
        [-25.60790104093985, 37.7498641258549],
        [-25.507650796799226, 37.70207135357383],
        [-25.167074624924226, 37.73248850435716],
        [-25.128622476486726, 37.7737489450442],
        [-25.1492218417211, 37.85403217356913],
        [-25.31676334562735, 37.864874561531046],
        [-25.4458527010961, 37.825834501370075],
        [-25.496664468674226, 37.852947847053834],
        [-25.54198307218985, 37.820410636321704],
        [-25.6820587557836, 37.844272660805125],
        [-25.78368229093985, 37.91689581864256],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-17.918151373276714, 28.85769184155718],
        [-17.93051099241734, 28.84686646222916],
        [-17.94973706663609, 28.83964891670097],
        [-18.009475225815777, 28.780686894339997],
        [-18.008101934800152, 28.755407244600022],
        [-17.98544263304234, 28.72951935610004],
        [-17.966903204331402, 28.665675317576753],
        [-17.927077764878277, 28.6120403598446],
        [-17.931197637925152, 28.592749181516833],
        [-17.913344854722027, 28.582499302712613],
        [-17.88381909788609, 28.534251169158534],
        [-17.88107251585484, 28.499257450642688],
        [-17.86184644163609, 28.45942289292848],
        [-17.83712720335484, 28.44855631576331],
        [-17.78768872679234, 28.542092995430675],
        [-17.76022290647984, 28.57285144527369],
        [-17.751296514878277, 28.623492820990236],
        [-17.76846265257359, 28.67832675783554],
        [-17.736190313706402, 28.718680661136855],
        [-17.72451734007359, 28.740356927263875],
        [-17.743056768784527, 28.761426764234983],
        [-17.785628790268902, 28.848069337800258],
        [-17.81240796507359, 28.84385921244503],
        [-17.84811353147984, 28.836039956173973],
        [-17.896865362534527, 28.840851875727815],
        [-17.918151373276714, 28.85769184155718],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-16.935791886932748, 28.34848396525356],
        [-16.847901261932748, 28.249332533145342],
        [-16.770996965057748, 28.09922101054937],
        [-16.685852922088998, 27.997413041806826],
        [-16.543030656463998, 28.03863263898562],
        [-16.422181047088998, 28.142823470507693],
        [-16.356263078338998, 28.314637766947033],
        [-16.359009660370248, 28.37265321922945],
        [-16.238160050995248, 28.4885889539271],
        [-16.147522843963998, 28.52237960283335],
        [-16.128296769745248, 28.56822102170524],
        [-16.180481828338998, 28.589928411980278],
        [-16.339783586151498, 28.57304527336006],
        [-16.438660539276498, 28.52237960283335],
        [-16.463379777557748, 28.447542908205314],
        [-16.661133683807748, 28.399233040111945],
        [-16.856141008026498, 28.396816968119797],
        [-16.935791886932748, 28.34848396525356],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-15.702576554901498, 28.164618048337022],
        [-15.705323136932748, 28.079836449188463],
        [-15.839905656463998, 27.975584516075465],
        [-15.749268449432748, 27.798367864393295],
        [-15.578980363495248, 27.73031748438485],
        [-15.430664933807748, 27.815373808370595],
        [-15.383973039276498, 27.868803721945046],
        [-15.381226457245248, 28.0192371471005],
        [-15.425171769745248, 28.074989761996136],
        [-15.400452531463998, 28.17914530160198],
        [-15.438904679901498, 28.19124983885919],
        [-15.493836320526498, 28.140401576910296],
        [-15.702576554901498, 28.164618048337022],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-17.314820207245248, 28.203353005587193],
        [-17.342286027557748, 28.116179629844797],
        [-17.306580461151498, 28.036208393659116],
        [-17.199463761932748, 28.021661774723498],
        [-17.119812883026498, 28.06771932116933],
        [-17.100586808807748, 28.123446788722646],
        [-17.185730851776498, 28.205773474435407],
        [-17.314820207245248, 28.203353005587193],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-17.943787492401498, 27.85666287088417],
        [-17.875122941620248, 27.815373808370595],
        [-17.952027238495248, 27.708435115708937],
        [-17.957520402557748, 27.63302892345553],
        [-18.042664445526498, 27.667089776512604],
        [-18.048157609588998, 27.69627634710402],
        [-18.166260636932748, 27.708435115708937],
        [-18.166260636932748, 27.764347993042136],
        [-18.039917863495248, 27.76920862612967],
        [-17.943787492401498, 27.85666287088417],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',
    geometry: {
      type: 'LineString',
      coordinates: [
        [-13.873308182260644, 28.787580639156392],
        [-14.043596268198144, 28.715341598914446],
        [-14.065568924448144, 28.551415045432293],
        [-14.197404861948144, 28.42105595469597],
        [-14.235857010385644, 28.213115455800715],
        [-14.477556229135644, 28.092033205647496],
        [-14.323747635385644, 28.03871367459841],
        [-14.158952713510644, 28.188909963238046],
        [-13.950212479135644, 28.217955896224055],
        [-13.878801346323144, 28.3630669680778],
        [-13.812883377573144, 28.599655311932988],
        [-13.873308182260644, 28.787580639156392],
      ],
    },
    properties: {},
  },
  {
    type: 'Feature',

    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [3.145, 39.79],
          [3.24, 39.756],
          [3.342, 39.787],
          [3.396, 39.777],
          [3.449, 39.761],
          [3.462, 39.698],
          [3.415, 39.627],
          [3.349, 39.556],
          [3.293, 39.477],
          [3.2447, 39.3874],
          [3.155, 39.333],
          [3.073, 39.301],
          [2.9, 39.368],
          [2.8, 39.385],
          [2.77, 39.41],
          [2.746, 39.51],
          [2.701, 39.542],
          [2.634, 39.556],
          [2.575878906250011, 39.530664062499994],
          [2.49951171875, 39.477880859375],
          [2.458789062500017, 39.53046875],
          [2.394335937500017, 39.540380859375],
          [2.370019531250023, 39.572070312499996],
          [2.371289062500011, 39.613085937499996],
          [2.784960937500017, 39.854833984375],
          [2.90478515625, 39.90830078125],
          [3.15869140625, 39.970507812499996],
          [3.197558593750017, 39.961083984374994],
          [3.164453125000023, 39.92421875],
          [3.1669921875, 39.90771484375],
          [3.198632812500023, 39.88984375],
          [3.19091796875, 39.861376953124996],
          [3.15869140625, 39.836572265624994],
          [3.145312500000017, 39.790087890624996],
        ],
      ],
    },
  },
  {
    type: 'Feature',

    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [4.293652343750011, 39.841845703124996],
          [4.275292968750023, 39.8302734375],
          [3.967675781250023, 39.945849609374996],
          [3.8671875, 39.958740234375],
          [3.842675781250023, 39.976367187499996],
          [3.845410156250011, 40.036474609375],
          [3.853417968750023, 40.063037109374996],
          [4.059179687500006, 40.075097656249994],
          [4.225781250000011, 40.032373046874994],
          [4.315136718750011, 39.917236328125],
          [4.322070312500017, 39.897509765624996],
          [4.293652343750011, 39.841845703124996],
        ],
      ],
    },
  },
  {
    type: 'Feature',

    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [1.593945312500011, 38.6720703125],
          [1.571191406250023, 38.658837890624994],
          [1.504980468750006, 38.67099609375],
          [1.40576171875, 38.67099609375],
          [1.401953125, 38.71142578125],
          [1.417187500000011, 38.74],
          [1.436328125000017, 38.768],
          [1.497, 38.712],
          [1.592, 38.701],
          [1.594, 38.672],
        ],
      ],
    },
  },
  {
    type: 'Feature',

    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [1.445, 38.919],
          [1.409, 38.857],
          [1.257, 38.879],
          [1.223, 38.904],
          [1.256, 38.973],
          [1.3, 38.982],
          [1.302, 39.031],
          [1.348, 39.081],
          [1.564, 39.121],
          [1.613, 39.087],
          [1.623, 39.0388],
          [1.494, 38.932],
          [1.445, 38.919],
        ],
      ],
    },
  },

  //Lanzarote

  {
    type: 'Feature',

    geometry: {
      type: 'Polygon',
      coordinates: [
        [
          [-13.469, 29.234],
          [-13.42, 29.206],
          [-13.426, 29.16],
          [-13.464, 29.126],
          [-13.45, 29.096],
          [-13.469, 29.015],
          [-13.622, 28.92],
          [-13.727, 28.911],
          [-13.786, 28.839],
          [-13.894, 28.88],
          [-13.833, 28.931],
          [-13.839, 29.032],
          [-13.598, 29.138],
          [-13.542, 29.119],
          [-13.517, 29.17],
          [-13.469, 29.234],
        ],
      ],
    },
  },
  // La Graciosa
  {
    type: 'Feature',

    geometry: {
      type: 'Polygon',
      coordinates: [[[-13.469, 29.271], [-13.51, 29.223], [-13.547, 29.225], [-13.514, 29.291], [-13.469, 29.271]]],
    },
  },
]
export default data
